{
    "logo": "Logo céphable",
    "add": "Ajouter",
    "all": "Tous",
    "edit": "Modifier",
    "create": "Créer",
    "delete": "Supprimer",
    "next": "Suivant",
    "previous": "Précédent",
    "search": "Recherche",
    "loading": "Chargement...",
    "reload": "Recharger",
    "cancel": "Annuler",
    "copy": "Copie",
    "save": "Sauvegarder",
    "saveAndFinish": "Enregistrer et terminer",
    "saveAndContinue": "Sauvegarder et continuer",
    "saved": "Enregistré",
    "done": "Fait",
    "back": "Dos",
    "play": "Jouer",
    "pause": "Pause",
    "success": "Succès",
    "continue": "Continuer",
    "options": "Possibilités",
    "share": "Partager",
    "finish": "Finition",
    "finishEdit": "Terminer Modifier",
    "advancedOptions": "Afficher les options avancées",
    "authenticating": "Authentification...",
    "skip": "Sauter",
    "close": "Fermer",
    "notFound": "Page non trouvée",
    "notFoundDescription": "Ah non ! Nous avons fouillé la mer et nous ne trouvons pas votre page !",
    "exitSetup": "Quitter la configuration",
    "experimental": "Expérimental",
    "letGetStarted": "Commençons!",
    "exploreInputControls": "Explorer les contrôles de saisie",
    "when": "Quand je ...",
    "thenMacro": "Cephable fonctionnera...",
    "controls": "Contrôles",
    "welcome": "Accueillir.",
    "beta": "bêta",
    "macroEmpty": "Aucune macro ne correspond à ces critères.",
    "you": "Toi",
    "step": "Étape",
    "steps": "Pas",
    "learnMore": "Apprendre encore plus",
    "dangerZone": "Zone dangereuse",
    "connected": "Connecté",
    "notConnected": "Pas connecté",
    "connectAndLearn": "Connectez-vous et apprenez",
    "tryAgain": "Essayer à nouveau",
    "by": "Par : {{value}}",
    "noName": "- sans nom -",
    "details": "Détails",
    "controlFeed": "Alimentation de contrôle",
    "wifi": {
        "disconnected": "Le Wi-Fi est déconnecté.",
        "connected": "Le Wi-Fi est connecté.",
        "description": "Connectez-vous au Wi-Fi pour permettre à Cephable de fonctionner avec vos connexions et logiciels. Vos capacités d'utilisation actuelles peuvent être limitées."
    },
    "signalR": {
        "disconnected": "La synchronisation est déconnectée.",
        "action": "Reconnecter",
        "description": "Il semble y avoir un problème de synchronisation avec Cephable. Cela pourrait entraîner des problèmes d'enregistrement de vos paramètres ou de communication avec d'autres connexions."
    },
    "billing": {
        "title": "Facturation",
        "expires": "Prochaine facturation : {{value}}",
        "isEmployeeAccess": {
            "title": "Professionnel",
            "titleLong": "Céphable Professionnel",
            "short": "Pro",
            "description": "Cephable Professional offre aux utilisateurs plus de puissance de productivité, en étendant l'IA locale et privée aux capacités génératives.",
            "supportedFeatures": {
                "tag": "Tout en Plus, plus",
                "features": [
                    "Génération de texte par IA",
                    "Réécriture par IA",
                    "Traduction par IA",
                    "Installations illimitées sur les appareils",
                    "Commandes d'application pré-entraînées illimitées",
                    "Partage illimité des commandes"
                ]
            }
        },
        "isDeveloperAccess": {
            "title": "Kit de développement logiciel (SDK)",
            "titleLong": "Kit de développement logiciel (SDK) Cephable",
            "short": "SDK",
            "description": "Les SDK Cephable vous permettent d'intégrer de puissants contrôles adaptatifs (voix, visage, tête, etc.) dans votre logiciel avec un minimum d'effort et un gain maximal.",
            "supportedFeatures": {
                "tag": "Tout en Plus, plus",
                "features": [
                    "Prise en charge de Windows et MacOS",
                    "SDK légers et intégrables pour la saisie hors ligne de la voix, du visage, de la tête et des actions rapides",
                    "Prise en charge API/webhook pour les actions de sortie personnalisées",
                    "Documentation du développeur",
                    "Exemples de projets",
                    "Transformez les commandes en automatisation et navigation de documents",
                    "Portail des développeurs pour gérer vos projets, vos clients d'authentification, vos types d'appareils, etc."
                ]
            }
        },
        "isStudentAccess": {
            "title": "Étudiant",
            "titleLong": "Éducation Céphable",
            "short": "Éducation",
            "description": "Cephable Education favorise l'apprentissage personnalisé et les classes inclusives. Cephable fonctionne hors ligne, sur appareil et ne nécessite aucune intégration tierce.",
            "supportedFeatures": {
                "tag": "Tout en Plus, plus",
                "features": [
                    "Installations d'appareils illimitées",
                    "Contrôles d'application pré-entraînés illimités",
                    "Partage illimité des contrôles d'application personnalisés"
                ]
            }
        },
        "viewProducts": "Voir les produits",
        "description": "Gérez la facturation de votre organisation, les sièges, les mises à niveau d'abonnement, le renouvellement ou l'annulation.",
        "view": "Gérer la facturation",
        "isResellerAccess": {
            "title": "Revendeur",
            "titleLong": "Revendeur Cephable",
            "description": "Cephable Reseller est une licence payante qui vous permet de créer de nouvelles organisations et d'attribuer des clés de licence. Cela inclut l'utilisation de Cephable avec votre propre suite logicielle et l'amélioration de votre expérience utilisateur.",
            "short": "Revendeur"
        },
        "error": "Veuillez contacter votre administrateur système pour gérer votre facturation.",
        "included": "Inclus avec votre licence {{licenseType}}.",
        "upgrade": {
            "description": "Effectuez une mise à niveau maintenant et faites passer vos commandes au niveau supérieur.",
            "action": "Mettre à niveau maintenant",
            "error": "Erreur lors de la mise à jour. Veuillez réessayer ultérieurement.",
            "requiredDetail": "Une licence {{licenseType}} est requise pour cette fonctionnalité. Vous pouvez passer à une version supérieure ou démarrer un essai gratuit dans les paramètres de votre compte.",
            "enableTextGeneration": "Générez du contenu en utilisant l'IA et votre voix.",
            "longDescription": "Passez à une licence payante pour accéder à toutes les fonctionnalités de Cephable. Des appareils multiples aux commandes avancées en passant par les intégrations personnalisées, Cephable vous offre tout ce dont vous avez besoin pour atteindre un niveau de productivité supérieur.",
            "compare": "Comparer les plans",
            "enableAiDictation": {
                "title": "Passez à la dictée intelligente",
                "description": "Effectuez une mise à niveau pour débloquer la dictée améliorée par l'IA. Je peux ajouter de la ponctuation, corriger les majuscules et m'adapter à votre style pour une écriture soignée sans effort supplémentaire."
            }
        },
        "isPlusAccess": {
            "title": "Plus",
            "titleLong": "Cephable Plus",
            "short": "Plus",
            "description": "Cephable Plus est destiné aux utilisateurs expérimentés qui souhaitent aller plus loin avec une voix intelligente, une dictée intelligente, des centaines de commandes d'applications et bien plus encore.",
            "supportedFeatures": {
                "tag": "Tout dans Basic, plus",
                "features": [
                    "Commandes vocales intelligentes (langage naturel)",
                    "Dictée intelligente (améliorée par l'IA)",
                    "Installation sur jusqu'à 3 appareils",
                    "Des centaines de commandes d'application pré-entraînées"
                ]
            }
        },
        "personal": {
            "short": "Basique",
            "title": "Basique",
            "titleLong": "Céphable Basic",
            "description": "Cephable Basic est gratuit à vie et conçu pour vous aider à progresser plus rapidement, à vous exprimer et à accomplir vos tâches à votre façon. Les fonctionnalités incluses dans la version Basic sont accessibles à tous les utilisateurs."
        },
        "mostPopular": "Le plus populaire",
        "subscription": {
            "options": "Options d'abonnement",
            "monthly": "Payer mensuellement",
            "billedMonthly": "/mois",
            "yearly": "Paiement annuel",
            "billedYearly": "/année"
        }
    },
    "organization": {
        "title": "Organisation",
        "titlePlural": "Organisations",
        "titleLong": "Professionnel céphable pour les organisations",
        "description": "Les organisations sont des groupes d'utilisateurs qui peuvent collaborer sur des projets et partager des ressources. Vous pouvez gérer votre équipe, les profils d’équipe, la facturation et bien plus encore ici.",
        "noAccess": {
            "title": "Accès refusé.",
            "description": "Vos autorisations ont récemment changé et vous n'avez plus accès à cette fonctionnalité. Si vous pensez qu'il s'agit d'une erreur, veuillez contacter l'administrateur de votre organisation."
        },
        "member": {
            "title": "Membre",
            "titlePlural": "Membres",
            "me": "Mon adhésion",
            "description": "Les membres sont des utilisateurs qui font partie de votre organisation. Ils peuvent être affectés à différents rôles et avoir accès à différentes parties de l’organisation.",
            "edit": "Modifier les membres",
            "removed": "Vous avez été supprimé d'une équipe.",
            "removedDescription": "Vous avez été retiré de l'équipe. Vous ne pouvez plus accéder à l'organisation. Si vous pensez qu'il s'agit d'une erreur, veuillez contacter l'administrateur de votre organisation.",
            "updated": "Bravo, l'adhésion de {{value}} a été mise à jour.",
            "error": "Erreur lors de la mise à jour de l'adhésion de {{value}}.",
            "delete": "Succès, {{value}} a été supprimé.",
            "deleteError": "Erreur lors de la suppression de {{value}}.",
            "deleteConfirmation": {
                "title": "Etes-vous sûr de vouloir supprimer ce membre ?",
                "description": "Une fois ce membre supprimé, il n'aura plus accès à l'organisation. Vous pourrez toujours le réinviter plus tard.",
                "confirm": "Oui, supprimer le membre"
            },
            "viewAll": {
                "title": "Voir tous les membres",
                "description": "Affichez tous les membres de votre organisation et gérez leurs rôles et autorisations."
            },
            "seats": {
                "title": "Sièges des membres",
                "description": "Chaque membre de votre organisation dispose d'un siège. Le type d'autorisations dont ils disposent peut être modifié par l'administrateur de l'organisation.",
                "stats": "sièges sur {{value}}",
                "max": "Nombre de places max.",
                "current": "Sièges actuels",
                "limit": {
                    "title": "Nombre maximal de sièges atteint",
                    "description": "Votre forfait actuel a atteint sa limite de {{ maxSeats }} sièges disponibles. Vous ne pouvez pas inviter de membres supplémentaires. Veuillez contacter votre administrateur pour mettre à niveau le forfait ou gérer votre attribution de sièges."
                },
                "updateLimit": {
                    "title": "Mettez à niveau votre forfait pour ajouter plus de sièges",
                    "description": "Votre forfait actuel a atteint le nombre maximal de sièges : {{ maxSeats }}. Effectuez une mise à niveau dès maintenant pour débloquer des sièges supplémentaires et garantir que votre équipe puisse continuer à se développer en toute transparence.",
                    "action": "Plan de mise à niveau"
                },
                "maxSeatValue": "Nombre maximal de sièges : {{value}}"
            },
            "aboutMe": "Sur moi",
            "loadError": "Erreur lors du chargement des membres de l'organisation.",
            "orgTitle": "Membres de {{value}} ",
            "emailExists": "L'e-mail existe déjà dans l'organisation. Veuillez saisir une autre adresse e-mail."
        },
        "invite": {
            "title": "Inviter",
            "titlePlural": "Invitations",
            "description": "Des invitations sont envoyées aux utilisateurs pour qu'ils rejoignent votre organisation. Vous pouvez inviter des utilisateurs à rejoindre votre organisation et leur attribuer différents rôles.",
            "edit": "Créer une nouvelle invitation",
            "view": "Afficher toutes les invitations",
            "emailRequired": "L'e-mail est requis",
            "emailInvalid": "Le courriel est invalide. S'il vous plaît, mettez une adresse email valide.",
            "emailExists": "L'e-mail dispose déjà d'une invitation d'organisation. Veuillez saisir une autre adresse e-mail.",
            "emailPlaceholder": "Entrer l'adresse e-mail",
            "expiration": "Expire ",
            "delete": "Supprimer l'invitation",
            "confirm": "Êtes-vous sûr de vouloir supprimer cette invitation ?",
            "confirmLong": "Une fois cette invitation supprimée, l'utilisateur ne pourra plus rejoindre l'organisation. Vous pourrez toujours les réinviter plus tard.",
            "accept": "Accepter l'invitation",
            "acceptSuccess": {
                "title": "Bienvenue dans l'équipe.",
                "description": "Vous avez rejoint l'organisation avec succès. ",
                "action": "Afficher votre nouvelle organisation"
            },
            "acceptError": {
                "title": "Oops. On dirait qu'il y a un problème.",
                "description": "Une erreur s'est produite lors de l'adhésion à l'organisation. Veuillez réessayer plus tard. Si le problème persiste, veuillez contacter l'administrateur de votre organisation. ",
                "action": "Retour à la page d'accueil"
            },
            "send": {
                "success": "Invitation à {{value}} envoyée.",
                "error": "Erreur lors de l'envoi de l'invitation à {{value}}.",
                "title": "Envoyer une invitation"
            },
            "viewDescription": "Voir toutes les invitations actuelles qui n'ont pas été acceptées.",
            "new": "Inviter un membre",
            "stat": "invitations actives",
            "noInvites": {
                "title": "Aucune invitation.",
                "description": "Il semble qu'il n'y ait aucune invitation active pour votre organisation."
            },
            "error": "Erreur lors du chargement des invitations.",
            "orgTitle": "Invitations de {{ value }}",
            "editDescription": "Créez une nouvelle invitation pour qu'un utilisateur rejoigne votre organisation."
        },
        "role": {
            "title": "Rôle",
            "titlePlural": "Les rôles",
            "description": "Les rôles correspondent aux différents niveaux d'accès dont un utilisateur peut disposer dans votre organisation. Vous pouvez attribuer différents rôles aux utilisateurs pour contrôler ce qu'ils peuvent faire."
        },
        "isAdmin": {
            "title": "Administrateur",
            "description": "Les administrateurs ont un accès complet à l'organisation et peuvent gérer tous les aspects de l'organisation.",
            "conflict": "Ce membre est un administrateur. Vous n'êtes pas autorisé à modifier leurs rôles."
        },
        "canViewMembers": {
            "title": "Afficher les membres",
            "description": "Les utilisateurs disposant de cette autorisation peuvent voir tous les membres de l'organisation."
        },
        "canInviteMembers": {
            "title": "Inviter des membres",
            "description": "Les utilisateurs disposant de cette autorisation peuvent inviter de nouveaux membres dans l'organisation et gérer les invitations existantes."
        },
        "canChangeMemberPermissions": {
            "title": "Modifier les rôles des membres",
            "description": "Les utilisateurs disposant de cette autorisation peuvent modifier le rôle des autres membres de l'organisation."
        },
        "canRemoveMembers": {
            "title": "Supprimer des membres",
            "titleSingle": "Supprimer un membre",
            "action": "Retirer",
            "description": "Les utilisateurs disposant de cette autorisation peuvent supprimer d'autres membres de l'organisation.",
            "confirm": "Êtes-vous sûr de vouloir supprimer ce membre de l'organisation?",
            "confirmLong": "Une fois que vous aurez supprimé ce membre, il n’aura plus accès à l’organisation. Vous pourrez toujours les réinviter plus tard."
        },
        "canCreateAuthClients": {
            "title": "Créer des clients d'authentification",
            "description": "Les utilisateurs disposant de cette autorisation peuvent créer de nouveaux clients d'authentification pour l'organisation."
        },
        "canManageBilling": {
            "title": "Gérer la facturation",
            "description": "Les utilisateurs disposant de cette autorisation peuvent gérer les paramètres de facturation de l'organisation.",
            "error": "Vous n'êtes pas autorisé à gérer la facturation de cette organisation."
        },
        "metrics": {
            "lineChart": {
                "title": "Connexions Simultanées Moyennes",
                "description": "Ce graphique montre les connexions simultanées moyennes pour l'organisation et les données du projet au fil du temps.",
                "max": "Connexions Max: {{maxConnections}}",
                "project": "Total du Projet",
                "org": "Organisation Total"
            },
            "title": "Métrique",
            "description": "Les métriques sont des points de données qui vous aident à comprendre comment votre organisation utilise Cephable.",
            "view": "Afficher les métriques",
            "orgTitle": "Métriques de {{ valeur }}",
            "manage": {
                "title": "Indicateurs de performance",
                "description": "Téléchargez ou effacez les mesures de performances collectées lors de l’inférence du modèle."
            },
            "download": {
                "button": "Télécharger les métriques",
                "success": "Le fichier de métriques a été enregistré dans votre dossier Téléchargements.",
                "error": "Échec du téléchargement du fichier de métriques.",
                "noFile": "Aucun fichier de métriques trouvé. Essayez d'abord d'exécuter le modèle."
            },
            "clear": {
                "button": "Des indicateurs clairs",
                "success": "Les métriques ont été effacées.",
                "error": "Échec de l'effacement du fichier de métriques.",
                "confirm": {
                    "title": "Indicateurs de performance clairs",
                    "description": "Voulez-vous vraiment effacer tous les indicateurs de performance enregistrés ? Cette action est irréversible.",
                    "cancel": "Annuler",
                    "confirm": "Des indicateurs clairs"
                }
            }
        },
        "noOrg": {
            "title": "Aucune licence associée.",
            "description": "Vous n'êtes actuellement associé à aucune licence ni à aucun groupe de développeurs. L'accès au portail est réservé aux utilisateurs disposant d'une licence Cephable payante. Pour exploiter pleinement le potentiel de Cephable, commencez un essai gratuit."
        },
        "projects": {
            "title": "Projets",
            "description": "Utilisez des projets pour gérer l'accès sécurisé, configurer les interactions des appareils et rationaliser la manière dont vos applications envoient et reçoivent des commandes sur différentes plates-formes.",
            "name": "Nom de l'application",
            "stats": {
                "title": "Statistiques du projet",
                "connections": "Connexions totales",
                "all": {
                    "title": "Toutes les mesures du projet",
                    "description": "Métriques agrégées pour tous les projets associés à {{ orgName }}"
                },
                "card": "projets sur {{value}}",
                "users": "nombre total d'utilisateurs depuis {{date}}",
                "avgUsers": "Nombre moyen mensuel d'utilisateurs.",
                "concurrent": {
                    "title": "Nombre moyen de connexions simultanées au cours des {{days}} derniers jours",
                    "label": "Moy. simultanée",
                    "max": "Connexions maximales",
                    "overage": "Excédent",
                    "description": "Les connexions simultanées correspondent au nombre d'utilisateurs connectés à votre projet en même temps. Cette mesure vous aide à comprendre combien d'utilisateurs utilisent votre application simultanément."
                }
            },
            "projectType": {
                "title": "Type de projet",
                "description": "Les types de projets sont utilisés pour catégoriser vos projets et nous aider à choisir les SDK qui vous conviennent."
            },
            "accessDenied": {
                "generic": "Vous n'avez pas accès à ce projet.",
                "title": "Accès refusé.",
                "description": "Vous n'avez pas accès aux projets pour les consulter, les créer, les modifier ou les supprimer. Veuillez contacter votre administrateur pour y accéder."
            },
            "upgrade": {
                "title": "Mise à niveau vers le SDK Cephable",
                "description": "Cephable peut être intégré directement dans votre application, jeu ou service à l'aide de nos SDK. Les projets ne sont actuellement pas disponibles avec votre compte. Si vous pensez qu'il y a une erreur, veuillez contacter support@cephable.com.",
                "shortDescription": "Les projets ne sont actuellement pas disponibles avec votre compte. Contactez-nous pour effectuer une mise à niveau."
            },
            "limit": {
                "title": "Vous voulez plus de projets ?",
                "error": "Limite du projet atteinte.",
                "description": "Vous avez atteint le nombre maximum de projets pour votre organisation. Veuillez contacter votre administrateur pour mettre à niveau votre compte."
            },
            "create": {
                "title": "Créer un projet",
                "titleLong": "Commençons.",
                "first": {
                    "title": "Démarrez votre projet.",
                    "description": "Il semble que vous n'ayez pas encore créé de projet. Les clés et les appareils clients sont essentiels pour sécuriser la communication entre vos applications et nos services. Avec une clé client, vous pourrez intégrer les commandes vocales et de mouvement de la tête dans vos applications rapidement et en toute sécurité."
                },
                "details": {
                    "title": "Détails du projet",
                    "description": "Créez un nouveau projet pour gérer l'autorisation de votre application, les fonctionnalités de votre appareil et les intégrations SDK. Suivez les étapes ci-dessous pour configurer des interactions sécurisées et personnalisables pour vos utilisateurs."
                }
            },
            "sdk": {
                "title": "Télécharger le SDK",
                "description": "Accédez à notre puissant SDK développé pour faciliter les contrôles adaptatifs.",
                "select": {
                    "title": "Sélectionner le SDK",
                    "description": "Sélectionnez le SDK que vous souhaitez utiliser pour ce projet. Nos SDK permettent une intégration transparente des commandes adaptatives de voix et de mouvement de la tête sur différentes plateformes."
                }
            },
            "clients": {
                "title": "Autorisation des clients",
                "description": "Les clients d'autorisation gèrent l'accès sécurisé à vos applications. Définissez un client d'autorisation pour authentifier les utilisateurs et contrôler les interactions avec votre application.",
                "settings": "Paramètres d'autorisation",
                "configure": "Configurer le client d'autorisation",
                "create": "Créer un client d'autorisation",
                "max": "Projets max : {{value}}"
            },
            "secret": {
                "title": "Secret du client",
                "created": "Votre secret client a été créé.",
                "description": "Votre secret client ne sera affiché qu'une seule fois. Copiez-le maintenant et stockez-le dans un endroit sûr et sécurisé. <br> <br> Utilisez-le uniquement pour votre propre développement. Ne le partagez pas avec des services ou des applications tiers.",
                "copy": "Copie secrète",
                "rotate": {
                    "title": "Faire pivoter le secret client",
                    "description": "AVERTISSEMENT : cette action révoquera votre secret client existant et créera un nouveau secret client. Cela vous obligera à mettre à jour toutes vos utilisations existantes dans toutes vos applications. Cette action ne peut pas être annulée.",
                    "error": "Erreur lors de la rotation du secret. Veuillez réessayer plus tard."
                }
            },
            "key": {
                "title": "Clé client",
                "view": "Afficher la clé client",
                "delete": {
                    "title": "Supprimer la clé client",
                    "description": "AVERTISSEMENT : cette action supprimera votre clé client existante et tous les paramètres associés. Cette action ne peut pas être annulée.",
                    "error": "Erreur lors de la suppression de votre clé client.",
                    "success": "Votre projet a été supprimé."
                },
                "copy": "Copier la clé"
            },
            "tokenRedirect": {
                "title": "URL de redirection de jeton",
                "description": "Les URL de redirection de jetons sont les points de terminaison où les jetons d'accès sont envoyés une fois l'authentification terminée. Ces URL permettent à votre application de recevoir en toute sécurité les jetons nécessaires pour accéder aux données et services utilisateur."
            },
            "authRedirect": {
                "title": "URL de redirection du code d'autorisation",
                "description": "L'URL de redirection AuthCode est le point de terminaison où les codes d'autorisation sont envoyés après qu'un utilisateur a accordé l'autorisation à votre application. Cette URL est essentielle dans les flux OAuth, car elle garantit la transmission sécurisée du code d'autorisation du serveur d'autorisation à votre application, vous permettant ainsi de demander des jetons d'accès au nom de l'utilisateur."
            },
            "scopes": {
                "title": "Portées",
                "titleLong": "Portées des autorisations API",
                "configure": "Définir les périmètres",
                "description": "Les portées définissent les autorisations dont disposera ce client d'autorisation. Définissez des portées pour limiter l'accès à des données et fonctionnalités spécifiques, en veillant à ce que les utilisateurs n'obtiennent que l'accès dont ils ont besoin.",
                "manage": "Gérer les portées d'autorisation"
            },
            "deviceScopes": {
                "title": "Types d'appareils associés",
                "titleLong": "Types d'appareils autorisés",
                "action": "Ajouter un nouveau type d'appareil",
                "configure": "Configurer les types d'appareils autorisés",
                "descriptionShort": "Définissez quel type d’appareils peuvent accéder à ce projet.",
                "titles": "Types d'appareils associés",
                "description": "Le type d'appareil définit les autorisations et les niveaux d'accès dont dispose un appareil dans votre application. En attribuant des types d'appareils spécifiques, vous pouvez contrôler les actions et les données auxquelles chaque appareil peut accéder, garantissant ainsi que votre application reste sécurisée et conforme à vos politiques de confidentialité."
            },
            "deviceType": {
                "title": "Types d'appareils",
                "description": "Un DeviceType définit une catégorie d'appareils, détaillant leurs capacités d'entrée/sortie et les fonctionnalités prises en charge (par exemple, la voix, les gestes, les types de contrôleur). Il garantit que seuls les appareils autorisés peuvent interagir avec une application, permettant un accès limité via des configurations d'appareils spécifiques, telles que Xbox ou PlayStation.",
                "action": "Créer un type d'appareil",
                "name": "Nom du type d'appareil",
                "descriptionLong": "Description du type d'appareil",
                "features": {
                    "title": "Fonctionnalités prises en charge",
                    "description": "Définissez les entrées et les sorties prises en charge par votre application. Cela nous aide à optimiser l'expérience utilisateur sur Cephable.",
                    "supportsVoiceInput": "Saisie vocale",
                    "supportsPhysicalInput": "Entrée physique",
                    "supportsKeyboardOutput": "Sortie clavier",
                    "supportsPlayStationControllerOutput": "Manette PlayStation",
                    "supportsFaceInput": "Saisie faciale",
                    "supportsGestureInput": "Saisie gestuelle",
                    "supportsXboxControllerOutput": "Manette Xbox",
                    "supportsDigitalExtensions": "Extensions numériques",
                    "supportsPhysicalExtensions": "Extensions physiques",
                    "supportsNintendoControllerOutput": "Manette Nintendo",
                    "supportsGenericControllerOutput": "Sortie du contrôleur générique"
                },
                "canAutoStart": {
                    "title": "Prend en charge les démarrages à contrôle automatique",
                    "description": "[canAutoStart] si activé, le SDK vérifiera les paramètres utilisateur et tentera de démarrer immédiatement les commandes de la caméra ou du microphone après la connexion de l'utilisateur."
                },
                "isSupported": {
                    "title": "Actif",
                    "description": "[isSupported] Si cette option est désactivée, Cephable n'enverra, ne recevra et n'accusera réception d'aucun appareil utilisateur associé à cette option. Équivalent à obsolète."
                },
                "locale": {
                    "title": "Langue par défaut",
                    "description": "[defaultLocale] Paramètres régionaux par défaut pour ce type d'appareil. Ils seront utilisés comme langue par défaut pour l'appareil.",
                    "support": "Langues prises en charge",
                    "warn": "** Il semble que vous ayez configuré des contrôles personnalisés. Veuillez vous assurer que vous avez mis à jour les contrôles personnalisés pour les langues associées.**",
                    "name": "{{lang}} - Nom du type d'appareil",
                    "langDescription": "{{lang}} - Description"
                },
                "customControls": {
                    "title": "Contrôles personnalisés",
                    "object": "{{lang}} - Objet de contrôles personnalisés",
                    "description": "Les contrôles personnalisés sont une option avancée permettant aux utilisateurs de configurer et de modifier manuellement les contrôles d'application associés à cet appareil. Si vous souhaitez que les utilisateurs contrôlent votre appareil directement depuis Cephable, vous devez enregistrer les contrôles de votre appareil ici. Consultez l'API Cephable pour plus de détails sur les options."
                },
                "success": {
                    "title": "Succès!",
                    "description": "Vous avez créé un nouveau type d'appareil. {{name}} Vous pouvez désormais mettre à jour la portée de votre appareil client d'autorisation selon vos besoins."
                },
                "id": "ID du type d'appareil"
            },
            "view": "Voir les projets",
            "error": "Erreur lors du chargement des projets.",
            "type": {
                "title": "Type d'implémentation"
            },
            "originHost": {
                "title": "Hôte d'origine",
                "description": "L'URL qui servira de source principale pour la demande et les données lors des interactions API."
            },
            "orgTitle": "Projets de {{ valeur }}"
        },
        "viewOrganization": "Voir L'organisation",
        "update": "Votre organisation a été mise à jour ! Actualisation de l'application.",
        "error": "Erreur lors du chargement de l'organisation. Veuillez réessayer ultérieurement.",
        "new": {
            "name": {
                "label": "Nom de l'organisation",
                "placeholder": "Entrez le nom de votre organisation"
            },
            "description": {
                "label": "Description de l'organisation",
                "placeholder": "Quels sont vos objectifs en utilisant Cephable Professional ?"
            },
            "details": "Détails de l'organisation"
        },
        "expired": {
            "user": "Il semble que votre licence Cephable ait expiré. Pour la renouveler, veuillez contacter l'administrateur de votre organisation.",
            "admin": "Il semble que votre licence Cephable ait expiré. Veuillez renouveler votre licence pour continuer à utiliser l'application.",
            "multiple": "Il semble que vos licences Cephable aient expiré. Veuillez renouveler au moins une de vos licences pour continuer à utiliser l'application.",
            "dialog": {
                "title": "Sélectionnez une organisation",
                "description": "Plusieurs organisations sont associées à votre compte. Veuillez sélectionner l'organisation que vous souhaitez renouveler."
            },
            "title": "Votre licence Cephable a expiré",
            "titlePlural": "Vos licences Cephable ont expiré",
            "banner": "Il semble que votre licence Cephable Premium ait expiré. En la renouvelant, accédez à des fonctionnalités telles que les commandes vocales améliorées, les tâches intelligentes IA et de nombreuses commandes d'applications prédéfinies."
        },
        "orgName": "Nom de l'organisation",
        "menu": {
            "title": "Menu Organisation",
            "view": "Voir le menu",
            "expand": "Développer le menu"
        },
        "settings": {
            "title": "Paramètres de l'organisation",
            "description": "Gérez la facturation, le nom, la description et les ressources de votre organisation.",
            "view": "Afficher les paramètres",
            "general": {
                "title": "Général"
            },
            "resources": {
                "edit": "Modifier les ressources",
                "description": "Utilisez l'éditeur Markdown sur la gauche pour mettre à jour et formater des ressources utiles pour tous les membres de l'organisation. Au fur et à mesure que vous saisissez du texte, l'aperçu sur la droite montre comment votre contenu apparaîtra aux utilisateurs. Vous pouvez ajouter des titres, des listes, des liens et d'autres éléments de mise en forme à l'aide de la syntaxe Markdown. Les modifications seront visibles pour les membres une fois enregistrées."
            },
            "other": {
                "title": "Autres paramètres",
                "description": "Gérez la facturation, le nom, la description et les ressources de votre organisation."
            }
        },
        "managed": {
            "title": "Organisation gérée",
            "titlePlural": "Organisations gérées",
            "description": "Les organisations gérées sont des organisations gérées par un revendeur Cephable. Les revendeurs peuvent gérer votre équipe, les profils d'équipe, la facturation et bien plus encore ici.",
            "error": "Erreur lors du chargement des organisations gérées.",
            "empty": {
                "title": "Aucune organisation gérée trouvée.",
                "description": "Il ne semble pas qu'aucune organisation gérée ne corresponde à ces critères. Ou vos clés de licence n'ont pas encore été activées."
            },
            "titleShort": "Géré"
        },
        "canManageChildOrganizations": {
            "title": "Gérer les organisations pour enfants",
            "description": "Les utilisateurs disposant de cette autorisation peuvent créer et gérer des organisations enfants en tant qu’administrateur."
        },
        "canViewAnalytics": {
            "title": "Voir les analyses",
            "description": "Les utilisateurs disposant de cette autorisation peuvent afficher les mesures et les analyses de l’organisation."
        },
        "create": "Créer une nouvelle organisation",
        "orgCustomBillingUrl": {
            "title": "URL de facturation personnalisée",
            "description": "Il s'agit d'une URL personnalisée qui sera utilisée pour rediriger l'utilisateur vers votre système de facturation (celui du revendeur). Doit commencer par « https:// » ou « mailTo : »"
        },
        "upgrade": {
            "existing": {
                "title": "Vous faites partie d'une licence existante.",
                "description": "Veuillez effectuer une mise à niveau en cliquant sur « {{action}} » dans le menu latéral."
            }
        },
        "restrictions": {
            "isGenAIDisabled": {
                "title": "IA générative désactivée",
                "description": "Votre organisation a désactivé l'accès aux fonctionnalités d'IA générative. Veuillez contacter l'administrateur de votre organisation pour plus d'informations."
            },
            "isRemoteControlDisabled": {
                "title": "Synchronisation entre appareils désactivée",
                "description": "Votre organisation a désactivé l'accès à la synchronisation. Vous ne pourrez donc pas utiliser notre application compagnon ni contrôler les appareils externes. Veuillez contacter l'administrateur de votre organisation pour plus d'informations."
            }
        }
    },
    "customControls": {
        "title": "Contrôles globaux et des appareils",
        "prefixDisclaimer": " Il s'agit d'un contrôle de préfixe ; il écoutera les mots après la commande, puis recherchera la phrase suivante pour trouver des correspondances.",
        "allowPausedDisclaimer": " Cette commande fonctionnera même lorsque le microphone est en pause.",
        "conflictIndicators": {
            "warn": "Avertissement: ",
            "title": "Conflits de configuration d'entrée détectés",
            "globalControls": "Conflits de configuration de contrôle global",
            "deviceControls": "Conflits de configuration du contrôle des périphériques",
            "usedInput": " est utilisé comme entrée pour ",
            "description": "Certaines entrées de vos contrôles globaux et d'appareil sont également utilisées dans un ou plusieurs de vos contrôles d'application. Cela peut entraîner des conflits avec Cephable. Dans ce cas, nous privilégierons toujours le contrôle d'application par rapport au contrôle global ou d'appareil.",
            "item": "L&#39;entrée <strong>{{value}}</strong> est utilisée dans les contrôles de votre application : ",
            "globalDescription": "Les contrôles globaux suivants ont des entrées en conflit avec les contrôles de votre application.",
            "deviceDescription": "Les commandes de l'appareil suivantes ont des entrées en conflit avec les commandes de votre application."
        },
        "globalControls": {
            "title": "Contrôles globaux",
            "empty": "Vous n'avez pas encore de contrôles globaux. Cliquez ci-dessous pour en créer un.",
            "edit": "Modifier les contrôles globaux",
            "description": "Les commandes globales sont toujours disponibles, quels que soient les contrôles de l'application ou l'appareil utilisé. Certaines fonctionnent même lorsque les commandes de votre microphone ou de votre appareil photo sont en pause."
        },
        "deviceControls": {
            "title": "Contrôles des appareils",
            "empty": "Vous n'avez pas encore de commandes d'appareil. Cliquez ci-dessous pour en créer un.",
            "edit": "Modifier les contrôles de l'appareil",
            "controls": {
                "cephable-open-app": {
                    "success": "Ouvrir l'application : {{value}}",
                    "error": "Impossible de trouver l'application : {{value}}"
                },
                "cephable-close-app": {
                    "commands": ["fermer"],
                    "name": "Fermer l'application par nom",
                    "description": "Utilisez cette commande avec les commandes vocales pour fermer une application sur votre ordinateur par son nom.",
                    "success": "Fermer l'application : {{value}}",
                    "error": "Impossible de trouver l'application : {{value}}"
                },
                "cephable-minimize-focused-app": {
                    "commands": ["minimiser"],
                    "name": "Réduire l'application actuellement sélectionnée.",
                    "description": "Utilisez cette commande avec les commandes vocales pour minimiser l’application actuellement sélectionnée.",
                    "success": "Minimisez le succès des applications ciblées !",
                    "error": "Erreur lors de la minimisation de l'application focalisée."
                },
                "cephable-maximize-focused-app": {
                    "commands": ["maximiser"],
                    "name": "Maximisez l'application actuellement sélectionnée.",
                    "description": "Utilisez cette commande avec les commandes vocales pour maximiser l'application actuellement sélectionnée.",
                    "success": "Maximisez le succès de votre application ciblée !",
                    "error": "Erreur lors de la minimisation de l'application focalisée."
                },
                "cephable-generate-text": {
                    "commands": ["générer"],
                    "name": "Générez du texte en fournissant l'invite suivant cette commande.",
                    "description": "Utilisez cette commande avec des commandes vocales suivies de votre invite pour générer du texte associé."
                },
                "cephable-stop-generate-text": {
                    "commands": [
                        "arrêter de générer",
                        "arrêter la génération",
                        "annuler générer",
                        "annuler la génération"
                    ],
                    "name": "Arrêtez de générer du texte.",
                    "description": "Utilisez cette commande avec les commandes vocales pour arrêter de générer du texte"
                },
                "cephable-open-panel": {
                    "commands": ["afficher le panneau"],
                    "name": "Ouvrir le panneau Cephable",
                    "description": "Utilisez cette commande avec les commandes vocales pour ouvrir le panneau Cephable."
                },
                "cephable-close-panel": {
                    "commands": ["masquer le panneau"],
                    "name": "Masquer le panneau Cephable",
                    "description": "Utilisez cette commande avec les commandes vocales pour masquer ou réduire le panneau Cephable."
                },
                "cephable-close-focused-app": {
                    "commands": ["courant proche"],
                    "name": "Fermez l'application actuellement sélectionnée.",
                    "description": "Utilisez cette commande avec les commandes vocales pour fermer l’application actuellement sélectionnée.",
                    "success": "Fermer l'application actuelle avec succès !",
                    "error": "Erreur lors de la fermeture de l'application actuelle."
                },
                "cephable-rewrite-text": {
                    "commands": ["récrire"],
                    "name": "Réécrivez le texte en fournissant l'invite suivant cette commande.",
                    "description": "Utilisez cette commande avec les commandes vocales suivies de votre invite pour réécrire votre texte en surbrillance actuel."
                },
                "cephable-summarize-text": {
                    "commands": ["résumer"],
                    "name": "Résumez le texte en fournissant l’invite suivant cette commande.",
                    "description": "Utilisez cette commande avec les commandes vocales suivies de votre invite pour résumer votre texte actuellement en surbrillance."
                },
                "cephable-translate-text": {
                    "commands": ["traduire"],
                    "name": "Traduisez le texte en fournissant l'invite suivant cette commande.",
                    "description": "Utilisez cette commande avec les commandes vocales suivies de votre invite pour traduire votre texte actuellement en surbrillance."
                },
                "cephable-click-by-name": {
                    "commands": ["robinet", "frapper", "naviguer vers", "aller à"],
                    "name": "Appuyez sur l'élément par nom",
                    "description": "Appuyez sur un élément de la page par son nom, par exemple « appuyer sur Enregistrer » pour cliquer sur un bouton nommé « Enregistrer »."
                }
            },
            "description": "Les commandes de l'appareil sont liées à l'appareil ou à la connexion que vous utilisez. Elles sont disponibles sans avoir à les ajouter aux commandes de votre application et sont particulièrement utiles pour les fonctionnalités ou événements uniquement pris en charge sur certains appareils."
        },
        "resetControls": {
            "title": "Réinitialiser les Commandes",
            "description": "La langue de votre voix a changé depuis la dernière mise à jour de vos commandes. Remarque : cette opération réinitialisera vos commandes pour qu'elles correspondent à {{language}} et vous risquez de perdre toutes les commandes personnalisées. Êtes-vous sûr de vouloir réinitialiser ?",
            "confirm": "Oui, réinitialiser les commandes",
            "error": "Une erreur s'est produite lors de la réinitialisation de vos commandes. Veuillez réessayer ultérieurement."
        },
        "warn": "Le microphone n'est pas activé. Vous devez activer votre microphone pour utiliser les commandes globales et celles de l'appareil.",
        "changeProfile": {
            "success": "Modifier les contrôles de l'application : {{value}}",
            "error": "Impossible de trouver les contrôles de l'application : « {{value}} »"
        },
        "descriptionShort": "Les commandes globales et d'appareil sont des actions toujours disponibles, conçues pour fonctionner avec tous les logiciels. Les commandes globales, comme « Arrêter la caméra », sont applicables à l'ensemble du système et indépendantes des applications, tandis que les commandes d'appareil sont adaptées à chaque connexion et débloquent des fonctionnalités plus avancées que les commandes d'application standard.",
        "description": "Les commandes globales et celles des appareils sont des actions toujours disponibles, conçues pour fonctionner avec tous les logiciels. Les commandes globales, comme « Arrêter la caméra », sont applicables à l'ensemble du système et indépendantes des applications, tandis que les commandes des appareils sont adaptées à chaque connexion et débloquent des fonctionnalités plus avancées que les commandes d'application standard. Ces commandes sont actuellement accessibles par commande vocale, mais nous prendrons en charge d'autres commandes ultérieurement."
    },
    "notifications": {
        "title": "Notifications",
        "center": "Centre de notification",
        "empty": "Vous n'avez aucune notification pour le moment. Revenez une autre fois.",
        "seen": "Vu",
        "markAsRead": "Marquer comme lu",
        "view": "Afficher toutes les notifications {{value}}"
    },
    "unsaved": {
        "title": "Vous avez des changements non enregistrés.",
        "description": "Vous avez des changements non enregistrés. Êtes-vous sûr de vouloir quitter cette page ?",
        "cancel": "Quitter sans sauvegarder",
        "confirm": "Sauvegarder et quitter"
    },
    "login": {
        "welcome": "Bienvenue chez Céphable !",
        "subtitle": "Contrôlez votre technologie selon <strong>vos</strong> conditions.",
        "create": "Créer un compte",
        "signIn": "Se connecter",
        "loading": "Redirection vers la connexion...",
        "error": "Une erreur s'est produite lors de votre connexion. Veuillez vous reconnecter.",
        "existingAccount": "Vous avez déjà un compte?",
        "description": "Prenez le contrôle total de votre ordinateur, de vos applications et de vos jeux avec Cephable : votre IA personnelle pour des actions rapides, des commandes vocales, des expressions faciales, des gestes, l'inclinaison et bien plus encore. Pas de traitement cloud. Juste un contrôle fluide qui s'adapte à vos mouvements."
    },
    "home": {
        "title": "Maison",
        "startControls": "Allume ça!",
        "manage": "Configurer",
        "profileGenerate": {
            "title": "Oups. On dirait que vous n'avez pas encore de contrôles d'application.",
            "description": "Pour que Cephable puisse contrôler votre ordinateur, nous devons savoir ce que vous souhaitez contrôler. Vous pouvez créer des contrôles d'application de A à Z ou nous demander de vous aider à en créer un grâce à notre générateur de contrôles."
        }
    },
    "wizard": {
        "description": "Cephable utilisera ensuite ces informations pour générer des contrôles que vous pourrez examiner et essayer !",
        "includeDefaultKeysQuestion": "Inclure les commandes vocales par défaut pour les touches et les clics de souris ?",
        "placeholderAppName": "Microsoft Word, Minecraft, YouTube, Code, etc.",
        "generate": "Générer des contrôles",
        "complete": {
            "title": "Très bien, nous avons terminé !",
            "description": "Cliquez sur le bouton ci-dessous pour afficher les contrôles que nous avons générés. Vous pourrez modifier, ajouter ou supprimer manuellement n'importe quel aspect pour le perfectionner vous-même.",
            "viewControls": "Voir mes contrôles"
        },
        "error": {
            "emptyInput": "Veuillez sélectionner au moins une méthode de saisie",
            "emptyApp": "Veuillez saisir au moins un nom d'application",
            "generatingProfile": "Erreur lors de la génération des contrôles de l'application"
        },
        "loading": {
            "title": "Nous rassemblons toutes les pièces",
            "description": "Cela peut prendre jusqu'à environ une minute. Ne quittez pas cette page et ne revenez pas en arrière, sinon elle cessera de générer."
        },
        "selectedTips": {
            "title": "Conseil n° {{count}}",
            "previous": "Conseil précédent",
            "next": "Prochain conseil",
            "two": "Vous pouvez contrôler la sensibilité de vos entrées dans la section « Paramètres de contrôle d'expression » du panneau principal. Cela vous permet d'affiner davantage la manière dont Cephable interprète les entrées qui vous sont spécifiques. Et Cephable s'améliore avec le temps à mesure qu'il fonctionne avec vous !",
            "three": "Après avoir configuré cela, vous avez toujours un contrôle total sur la configuration. Nous vous donnons une base de référence, mais à tout moment, vous pouvez modifier le mappage entre ce que vous faites et ce qu'il fait sur l'ordinateur.",
            "four": "Vous pouvez imprimer vos contrôles pour en avoir une copie physique lorsque vous utilisez Cephable. Nous savons que tout cela est nouveau et qu’il faut un certain temps pour s’y habituer. La pratique rend meilleur !",
            "one": "Saviez-vous que vous pouvez utiliser Cephable sur un appareil pour en contrôler un autre ? Téléchargez Cephable sur votre mobile, votre tablette ou même un autre ordinateur et choisissez la connexion que vous souhaitez contrôler (peut-être celle-ci). Vos profils personnels et de saisie sont cohérents sur tous vos appareils ! Assurez-vous simplement que Cephable est actif sur votre appareil et vos connexions."
        },
        "steps": {
            "one": "Étape 1. Tapez le nom d'une application que vous souhaitez contrôler.",
            "two": "Étape 2. Confirmez les contrôles de saisie que vous souhaitez utiliser :",
            "three": "Étape 3. (facultatif) ",
            "threeContinued": "Décrivez toutes les actions spécifiques que vous souhaiteriez configurer pour les commandes que vous utilisez couramment ou pour lesquelles vous avez une forte préférence. Veuillez utiliser un anglais simple comme ceux ci-dessous"
        },
        "noOptionsText": "Commencez à taper pour trouver une application que vous souhaitez contrôler",
        "title": "Générer des contrôles d'application",
        "titleLong": "Générer des contrôles d'application",
        "try": "Essayez le générateur de contrôle",
        "placeholder": "Assurez-vous que les commandes vocales soient courtes.\n\nJe souhaite pouvoir dire « avancer » pour passer à la diapositive suivante de la présentation.\n\nJe souhaite utiliser les mouvements de la tête pour déplacer le curseur et les commandes vocales pour modifier les raccourcis.\n\nAjouter des boutons d'action rapide pour tous les mouvements et capacités de mon personnage."
    },
    "macros": {
        "title": "Contrôle",
        "titlePlural": "Contrôles",
        "description": "Les contrôles contiennent une entrée (action que vous faites comme incliner la tête) et les étapes que Cephable effectuera après l'enregistrement de cette action d'entrée. Vous pouvez utiliser des contrôles pour créer une combinaison d'étapes déclenchées par une seule entrée.",
        "new": "Créer un nouveau contrôle",
        "newDescription": "Créez un nouveau contrôle pour combiner plusieurs étapes et entrées.",
        "add": "Ajouter un contrôle",
        "create": "Créer un contrôle",
        "name": {
            "title": "Nom du contrôle",
            "question": "Comment voulez-vous appeler ce contrôle ?",
            "description": "Donnez un nom à votre contrôle afin de pouvoir le retrouver facilement plus tard.",
            "placeholder": "action que ce contrôle fait comme \"sauter\" ou \"zoomer\""
        },
        "empty": "Vous n'avez pas encore de contrôles. Cliquez ci-dessous pour en créer un.",
        "copySuffix": "{{nom}}_copie"
    },
    "event": {
        "title": "Étape",
        "titlePlural": "Pas",
        "previewSummaryPlural": "{{first}} et {{total}} autres événements",
        "add": "Ajouter une étape",
        "stepType": "Type d'étape",
        "select": "Sélectionnez le type d'étape que vous souhaitez ajouter.",
        "question": "Quel type d’actions souhaitez-vous que Cephable effectue ?",
        "setup": "Configurez votre étape",
        "description": "Les étapes sont les actions que Cephable effectuera une fois l'entrée déclenchée. Vous pouvez ajouter plusieurs étapes à un contrôle pour créer une combinaison d'actions.",
        "expand": "Développez pour voir le reste des étapes",
        "stepUp": "Progresser",
        "stepDown": "Descendre",
        "stepCopy": "Étape de copie",
        "stepRemove": "Supprimer l'étape",
        "insertStep": "Insérer l'étape ci-dessous",
        "showOptions": "Afficher les options",
        "hideOptions": "Masquer les options",
        "hold": "Temps de maintien (en millisecondes)",
        "error": "Vous devez configurer votre étape.",
        "multiple": "Plusieurs étapes",
        "deviceTypeCustomAction": {
            "title": "Action personnalisée sur l'appareil"
        },
        "keyPress": {
            "title": "Appuyez sur la touche ou le bouton ",
            "short": "Presse",
            "fieldSet": "Touches ou boutons sur lesquels appuyer",
            "label": "Clé ou bouton",
            "holdTime": "Temps de maintien de la touche (en millisecondes)",
            "description": "Appuyez sur une touche du clavier sans utiliser le clavier.",
            "longDescription": "Cette fonction simule l'appui sur une touche de votre clavier. Par exemple, si vous rencontrez des difficultés pour appuyer sur des touches physiques, vous pouvez utiliser une commande vocale ou une autre méthode de saisie pour « appuyer » virtuellement sur une touche.",
            "example": "Dites « Entrée » pour envoyer un e-mail sans appuyer physiquement sur la touche Entrée.",
            "timing": "Synchronisation des touches",
            "tap": "Robinet",
            "tapLong": "Appuyez sur le bouton",
            "latch": "Loquet",
            "latchLong": "Tenir jusqu'à ce qu'il soit relâché",
            "hold": "Prise",
            "holdLong": "Tenir pendant un certain temps",
            "latchLabel": "Conservez <strong>{{value}}</strong> jusqu&#39;à ce qu&#39;il soit libéré",
            "tapLabel": "Appuyez sur <strong>{{value}}</strong>",
            "pressLabel": "Appuyez sur <strong>{{value}}</strong> pendant <strong>{{time}}</strong> millisecondes",
            "remove": "Supprimer la touche enfoncée",
            "add": "Ajouter une touche/un bouton sur lequel appuyer"
        },
        "keyRelease": {
            "title": "Relâcher la touche ou le bouton",
            "short": "Libérer",
            "selected": "Clés sélectionnées à libérer",
            "description": "Lâchez une touche du clavier que vous avez enfoncée et maintenue enfoncée.",
            "longDescription": "Cette fonction simule le relâchement d'une touche de votre clavier. Il doit être utilisé conjointement avec une pression sur une touche maintenue indéfiniment. Par exemple, si vous rencontrez des difficultés pour appuyer sur des touches physiques, vous pouvez utiliser une commande vocale ou une autre méthode de saisie pour « relâcher » virtuellement une touche.",
            "example": "Dites « Stop » après avoir dit « Toggle Run » pour arrêter de fonctionner.",
            "label": "Libérer <strong>{{value}}</strong>",
            "add": "Ajouter une clé/un bouton pour libérer",
            "remove": "Supprimer la version de clé"
        },
        "keyToggle": {
            "title": "Touche ou bouton à bascule",
            "short": "Basculer",
            "selected": "Touches sélectionnées à basculer",
            "description": "Allumez ou éteignez une touche du clavier comme un interrupteur d'éclairage avec une seule commande.",
            "longDescription": "Cela active ou désactive la fonction d'une touche, comme un interrupteur. C'est utile pour les clés que vous souhaitez conserver pendant une durée indéterminée. Vous pouvez l'utiliser pour conserver la même action pour l'appui sur une touche et pour le relâchement ou l'arrêt d'une touche.",
            "example": "Dites « Toggle Run » pour commencer à courir. Dites « Toggle Run » pour arrêter de fonctionner.",
            "label": "Basculer <strong>{{value}}</strong>",
            "add": "Ajouter une clé/un bouton pour basculer",
            "remove": "Supprimer la bascule de clé"
        },
        "pause": {
            "title": "Pause",
            "description": "Ajoutez un bref délai entre les actions.",
            "longDescription": "Cette fonction vous permet d'insérer un bref délai entre les actions, ce qui est essentiel dans les situations où une action doit être complètement terminée avant que la suivante ne commence. Par exemple, si vous utilisez une commande pour mettre le texte en gras dans un document, vous devrez peut-être d'abord ouvrir un menu contextuel. La fonction Pause donne suffisamment de temps pour que le menu contextuel s'ouvre et devienne actif avant de passer à l'étape suivante, garantissant ainsi un fonctionnement fluide et sans erreur.",
            "example": "Imaginez que vous modifiez un document à l'aide de commandes vocales. Vous dites « Formater le texte », ce qui ouvre un menu contextuel. Ensuite, après une brève pause pour permettre au menu d'apparaître entièrement, vous dites « Gras » pour appliquer une mise en forme en gras au texte sélectionné. La fonction Pause garantit que le menu contextuel est prêt à recevoir votre prochaine commande.",
            "label": "Pause pendant <strong>{{value}}</strong> millisecondes"
        },
        "type": {
            "title": "Taper",
            "field": "Phrase à saisir",
            "placeholder": "phrase dactylographiée",
            "question": "Quel texte souhaitez-vous taper ?",
            "description": "Écrivez du texte comme si vous utilisiez un clavier.",
            "longDescription": "Cela imite la saisie d’une chaîne de texte, comme si vous tapiez sur un clavier. C'est idéal pour saisir du texte plus long sans avoir besoin d'appuyer sur chaque touche. Si vous souhaitez saisir du texte de manière dynamique, vous pouvez utiliser la fonction Dictée.",
            "example": "Dites « Nom » pour saisir « Bonjour, je m'appelle Ellen Ripley ». dans une fenêtre de discussion.",
            "label": "Tapez <strong>{{value}}</strong>"
        },
        "mouseMove": {
            "title": "Déplacez la souris",
            "description": "Déplacez le pointeur sur l'écran.",
            "longDescription": "Déplacez le curseur ou le pointeur de votre écran sans souris physique. Ceci est particulièrement utile pour les utilisateurs ayant une mobilité limitée des mains. Ceci est utile pour un contrôle précis des mouvements de la souris, nécessaire dans certains jeux. Si vous souhaitez simuler tous les mouvements de la souris en utilisant le mouvement de votre tête, vous pouvez essayer le « Mouvement de la tête pour le contrôle de la souris » dans les paramètres de la caméra.",
            "example": "Dites « Déplacer la souris vers la droite » pour déplacer le curseur vers la droite de 100 px.",
            "moveX": "Déplacement de la souris vers la gauche/droite",
            "numberMoveX": "Nombre de pixels à déplacer vers la gauche/droite",
            "moveY": "Déplacement de la souris vers le haut/bas des pixels",
            "numberMoveY": "Nombre de pixels à déplacer vers le haut/bas",
            "label": "Déplacez la souris <strong>{{value}}</strong>",
            "command": "Déplacement de la souris : {{commande}}"
        },
        "joystickMove": {
            "title": "Déplacer les joysticks",
            "description": "Utilisez un joystick pour déplacer les éléments sur l'écran.",
            "longDescription": "Cette fonction simule le mouvement d'un joystick. Par exemple, si vous rencontrez des difficultés pour utiliser un joystick physique, vous pouvez utiliser une commande vocale ou une autre méthode de saisie pour déplacer virtuellement un joystick.",
            "example": "Dites « Déplacer le joystick vers la gauche » pour déplacer le joystick vers la gauche de 100 px.",
            "prefix": "Déplacez le joystick gauche",
            "left": "Manette gauche",
            "leftX": "X gauche",
            "leftY": "Y gauche",
            "right": "Manette droite",
            "rightX": "X droit",
            "rightY": "Y droit",
            "x": "Force de l'axe X",
            "y": "Force de l'axe Y",
            "moveXLabel": "Déplacer X : {{value}}",
            "moveYLabel": "Déplacement Y : {{value}}",
            "labelLeft": "Déplacez le joystick gauche ",
            "labelRight": "Déplacez le joystick droit ",
            "latch": "Le loquet maintiendra la position jusqu'à ce que vous le relâchiez à l'aide d'une commande « Arrêter tout »."
        },
        "playAudio": {
            "title": "Lire l'audio",
            "placeholder": "phrase de déclaration que Cephable dira",
            "description": "Jouez un son, un mot ou une phrase.",
            "longDescription": "Cette fonction permet aux utilisateurs de convertir des phrases saisies en mots prononcés. C'est particulièrement utile pour les personnes qui peuvent avoir des difficultés à parler. En tapant une phrase, la fonction PlayAudio articulera le texte à haute voix à l'aide d'une parole synthétisée. Cela peut faciliter la communication ou dans les situations où un utilisateur a besoin de relayer des informations verbalement mais préfère ou nécessite une alternative à l'utilisation de sa propre voix.",
            "example": "Souriez pour jouer le mot « Bonjour ».",
            "label": "Dites <strong>{{value}}</strong>"
        },
        "stopOutputs": {
            "title": "Arrêter toutes les sorties",
            "titleLong": "Arrêtez toutes les sorties (relâchez toutes les touches et boutons, arrêtez tous les mouvements de la souris, arrêtez toute saisie)",
            "description": "Arrêtez toutes les actions en cours comme l'appui sur une touche.",
            "longDescription": "Arrêtez immédiatement toutes les sorties ou actions en cours. Il s'agit d'une fonction de sécurité ou de commodité permettant d'arrêter tout processus. Nous le ferons automatiquement pour vous lorsque vous fermez ou mettez en pause les commandes de la caméra ou du microphone.",
            "example": "Dites « Stop » pour arrêter toutes les sorties.",
            "label": "Arrêtez toutes les sorties et relâchez les touches"
        },
        "custom": {
            "title": "Coutume"
        },
        "options": {
            "moveUp": "Déplacer vers le haut",
            "moveDown": "Descendre",
            "moveLeft": "Se déplacer à gauche",
            "moveRight": "Déplacer vers la droite",
            "copyStep": "Étape de copie",
            "removeStep": "Supprimer l'étape"
        },
        "directions": {
            "up": "En haut",
            "down": "Vers le bas",
            "left": "Gauche",
            "right": "Droite"
        }
    },
    "expression": {
        "title": "Expression du visage",
        "titlePlural": "Expressions du visage",
        "label": "Expression / Geste",
        "start": "Démarrer les contrôles d’expression",
        "startSmiling": {
            "title": "Commencez à sourire",
            "description": "Si vous commencez à sourire sans sourire, puis à sourire, cette commande se déclenchera. Remarque : l'utilisation de cette commande dans les mêmes commandes d'application que la commande « Ouvrir/Fermer la bouche » peut entraîner des conflits."
        },
        "stopSmiling": {
            "title": "Arrêtez de sourire",
            "description": "Si vous souriez puis cessez, cette commande s'activera. Remarque : l'utilisation de cette commande dans les mêmes commandes d'application que la commande « Ouvrir/Fermer la bouche » peut entraîner des conflits."
        },
        "eyebrows": {
            "title": "Lève sourcils",
            "description": "Si vous soulevez vos deux sourcils par rapport à votre position de repos de base, cette commande se déclenchera."
        },
        "openMouth": {
            "title": "Bouche ouverte",
            "description": "Si votre bouche est fermée (ou légèrement ouverte), et que vous l'ouvrez davantage, cette commande se déclenchera. Remarque : l'utilisation de cette commande dans les mêmes commandes d'application que la commande du sourire peut entraîner des conflits."
        },
        "closeMouth": {
            "title": "Fermer la bouche",
            "description": "Si votre bouche est ouverte et que vous la fermez complètement, cette commande se déclenchera. Remarque : l'utilisation de cette commande dans les mêmes commandes d'application que la commande de sourire peut entraîner des conflits."
        },
        "description": "Améliorez votre expérience numérique grâce aux expressions faciales. Utilisez des gestes comme lever les sourcils, sourires et autres mouvements pour contrôler facilement le pointeur de votre souris, effectuer des actions ou personnaliser vos interactions."
    },
    "head": {
        "title": "Mouvement de la tête",
        "titlePlural": "Mouvements de tête",
        "label": "Mouvement de la tête/du corps",
        "question": "Quel type de mouvement souhaitez-vous utiliser ?",
        "tilt": {
            "title": "Inclinaison de la tête",
            "left": {
                "title": "Incliner la tête vers la gauche",
                "description": "Si vous regardez la caméra et inclinez la tête vers la gauche, cette commande se déclenchera."
            },
            "right": {
                "title": "Incliner la tête vers la droite",
                "description": "Si vous regardez la caméra et inclinez la tête vers la droite, cette commande se déclenchera."
            },
            "back": {
                "title": "Incliner la tête vers l'arrière",
                "description": "Si vous regardez la caméra, inclinez la tête en arrière et regardez vers le haut, cette commande se déclenchera."
            },
            "forward": {
                "title": "Incliner la tête vers l'avant",
                "description": "Si vous regardez la caméra et inclinez la tête vers l’avant et regardez vers le bas, cette commande se déclenchera."
            },
            "description": "Inclinez votre tête vers la gauche ou la droite pour un contrôle amélioré ou une navigation avec la souris."
        },
        "turn": {
            "title": "Tour de tête",
            "left": {
                "title": "Tourner la tête à gauche",
                "description": "Si vous regardez la caméra et tournez la tête et regardez vers votre gauche, cette commande se déclenchera."
            },
            "right": {
                "title": "Tourner la tête à droite",
                "description": "Si vous regardez la caméra et tournez la tête et regardez vers votre droite, cette commande se déclenchera."
            },
            "description": "Tournez la tête vers la gauche ou la droite pour un contrôle amélioré ou une navigation avec la souris."
        },
        "lean": {
            "title": "Tête maigre",
            "left": {
                "title": "Pencher la tête à gauche",
                "description": "Si vous regardez la caméra et que vous vous penchez vers la gauche pour que votre visage soit plus à gauche dans le cadre de la caméra, cette commande se déclenchera."
            },
            "right": {
                "title": "Pencher la tête à droite",
                "description": "Si vous regardez la caméra et que vous vous penchez vers la droite pour que votre visage soit plus à droite dans le cadre de la caméra, cette commande se déclenchera."
            },
            "back": {
                "title": "Pencher la tête en arrière",
                "description": "Si vous regardez la caméra et que vous vous penchez en arrière pour que votre visage soit plus éloigné de la caméra, cette commande se déclenchera."
            },
            "forward": {
                "title": "Penchez-vous la tête en avant",
                "description": "Si vous regardez la caméra et que vous vous penchez en avant pour que votre visage soit plus proche de la caméra, cette commande se déclenchera."
            },
            "up": {
                "title": "Déplacer le corps vers le haut",
                "description": "Si vous regardez la caméra et que vous relevez la tête en étirant votre cou ou en déplaçant tout votre corps vers le haut, cette commande se déclenchera."
            },
            "down": {
                "title": "Descendre le corps",
                "description": "Si vous regardez la caméra et baissez la tête en froissant le cou, en vous baissant ou en abaissant tout votre corps, cette commande se déclenchera."
            },
            "center": {
                "title": "Centrez votre tête",
                "description": "Si vous regardez la caméra et déplacez votre tête vers la position centrale correspondant à la ligne de base, cette commande se déclenchera."
            },
            "description": "Penchez votre tête vers la gauche ou la droite pour un meilleur contrôle ou une meilleure navigation avec la souris."
        },
        "description": "Contrôlez votre appareil ou votre connexion par des mouvements de tête comme incliner, hocher la tête ou tourner. Grâce à la caméra de votre appareil, Cephable garantit une expérience privée et intuitive pour un contrôle et une navigation optimisés."
    },
    "voice": {
        "title": "Commande vocale",
        "titlePlural": "Commandes vocales",
        "placeholder": "Voix ou phrase que Cephable écoutera",
        "question": "Quelle déclaration ou expression voulez-vous dire pour ce contrôle ?",
        "when": "Quand je dis...",
        "say": "Dites « {{value}} »",
        "load": {
            "fail": {
                "title": "{{language}} Commandes vocales indisponibles",
                "description": "Oh non! Nous n'avons pas pu charger {{language}} pour les commandes vocales. S'il vous plaît, vérifiez votre connexion à internet et réessayez. Utiliser l'anglais (États-Unis) jusqu'à ce que la connexion soit rétablie."
            }
        },
        "description": "Activer le microphone permet des commandes vocales intelligentes et naturelles, permettant aux utilisateurs d'interagir facilement avec leur ordinateur, que ce soit pour les applications ou les logiciels. Exécutez des commandes ou dictez du texte en parlant naturellement, pour une expérience intuitive et intuitive."
    },
    "motion": {
        "title": "Contrôle de mouvement",
        "titlePlural": "Commandes de mouvement",
        "question": "Quel type de mouvement avec un téléphone ou une tablette souhaitez-vous utiliser ?",
        "start": "Démarrer les commandes de mouvement",
        "settings": "Paramètres de mouvement",
        "descriptionShort": "Inclinez, tournez ou secouez votre appareil pour contrôler Cephable.",
        "description": "Les commandes de mouvement vous permettent de transformer les mouvements de votre téléphone ou de votre tablette dans l'application Companion en commandes pour votre appareil. Inclinez ou secouez votre téléphone dans différentes directions pour créer de nouvelles sorties.",
        "up": {
            "title": "Inclinez votre appareil vers le haut",
            "description": "Si votre appareil est à plat sur une surface et que vous l'inclinez vers vous, cette commande se déclenchera."
        },
        "down": {
            "title": "Inclinez votre appareil vers le bas",
            "description": "Si votre appareil est à plat sur une surface et que vous l'inclinez pour qu'il soit face à vous, cette commande se déclenchera."
        },
        "left": {
            "title": "Inclinez votre appareil vers la gauche",
            "description": "Si votre appareil est plat sur une surface et que vous l'inclinez vers la gauche pour faire face vers la gauche, cette commande se déclenchera."
        },
        "right": {
            "title": "Inclinez votre appareil vers la droite",
            "description": "Si votre appareil est plat sur une surface et que vous l'inclinez vers la droite, cette commande se déclenchera."
        },
        "shake": {
            "title": "Secouez votre appareil",
            "description": "Si vous secouez votre appareil, cette commande se déclenchera."
        },
        "edit": {
            "title": "Modifier les paramètres de mouvement",
            "description": "Modifiez vos paramètres de contrôle de mouvement pour ajuster la quantité dont vous avez besoin pour déplacer votre téléphone pendant l'exécution vers l'application Companion.",
            "sensitivity": {
                "title": "Paramètres de sensibilité du contrôle de mouvement",
                "description": "La sensibilité indique à Cephable jusqu'où vous devez incliner votre appareil pour déclencher un contrôle. Plus la valeur est grande (la plus à droite sur le curseur), plus la sensibilité est élevée, et donc moins il faut incliner pour déclencher la commande."
            },
            "tilt": {
                "title": "Sensibilité à l'inclinaison",
                "description": "Ces valeurs déterminent jusqu'où vous devez incliner votre appareil vers le haut, le bas, la gauche et la droite pour qu'une entrée soit reconnue."
            },
            "mouse": {
                "title": "Commandes de mouvement pour le mouvement de la souris",
                "description": "Déterminez si et comment vous souhaitez utiliser les commandes de mouvement pour déplacer votre souris au lieu de déclencher les commandes",
                "enable": {
                    "title": "Activer les commandes de mouvement pour le mouvement de la souris",
                    "description": "Si cette option est activée, certaines de vos commandes de mouvement seront utilisées pour déplacer votre souris au lieu de déclencher des commandes.",
                    "option": "Utiliser les commandes de mouvement pour les mouvements de la souris ?"
                },
                "invert": {
                    "title": "Inverser le mouvement de la souris",
                    "description": "Pour l'axe X : si cette option est activée, un déplacement vers la gauche déplacera votre souris vers la droite et un déplacement vers la droite la déplacera vers la gauche. Pour l'axe Y : si cette option est activée, le fait de descendre déplacera votre souris vers le haut et le fait de monter la fera descendre.",
                    "x": "Inverser le mouvement de la souris sur l'axe X ?",
                    "y": "Inverser le mouvement de la souris sur l'axe Y ?"
                }
            }
        }
    },
    "keys": {
        "title": "Clé ou bouton",
        "titlePlural": "Touches ou boutons",
        "label": "Clé/bouton externe",
        "question": "Sur quelle touche ou bouton souhaitez-vous appuyer ?",
        "edit": "Modifier les touches et les boutons",
        "defaultOption": "Inclure les commandes vocales par défaut pour les touches et les clics de souris ?",
        "description": "Les touches et les boutons vous permettent de mapper vos différentes commandes d'entrée aux pressions du clavier et des boutons du contrôleur.",
        "then": "Cephable va appuyer...",
        "empty": "Aucun contrôle clé ne correspond à ces critères.",
        "backspace": "Retour arrière",
        "delete": "Supprimer",
        "enter": "Entrer",
        "space": "Barre d'espace",
        "tab": "Languette",
        "shift": "Changement",
        "ctrl": "Ctrl",
        "leftCtrl": "Ctrl gauche",
        "rightCtrl": "Ctrl droit",
        "leftShift": "Décalage à gauche",
        "rightShift": "Maj droite",
        "alt": "Tout",
        "leftAlt": "Alt gauche",
        "escape": "S'échapper",
        "up": "Flèche vers le haut",
        "down": "Flèche vers le bas",
        "left": "Flèche gauche",
        "right": "Flèche droite",
        "command": "Commande",
        "caps": "Verrouillage des majuscules"
    },
    "talkback": {
        "title": "Répondre",
        "question": "Que veux-tu que Céphable dise ?",
        "description": "Configurez des contrôles qui permettront à Cephable de parler pour vous. Vous pouvez attribuer des commandes aux différentes phrases que vous souhaitez prononcer.",
        "thenMacro": "alors Céphable dira...",
        "empty": "Il n'existe aucun contrôle de réponse correspondant à ces critères.",
        "add": "Ajouter un nouveau contrôle Talkback",
        "remove": "Supprimer le contrôle Talkback",
        "edit": "Modifier les commandes Talkback",
        "deprecatedNotice": "Talkback est désormais intégré directement aux commandes principales de l'application. Vos commandes d'application comportent d'anciens événements Talkback qui doivent être mis à jour."
    },
    "dictation": {
        "title": "Dictation",
        "question": "Quelle phrase doit déclencher le mode dictée ?",
        "thenMacro": "Céphable va...",
        "empty": "Il n'existe aucun contrôle de dictée correspondant à ces critères.",
        "type": "taper",
        "edit": "Modifier les phrases de dictée",
        "remove": "Supprimer une phrase de dictée",
        "add": "Ajouter une nouvelle phrase de dictée",
        "on": "Dictée",
        "off": "Commandes",
        "onboarding": {
            "tourLabel": "Dictée",
            "learn": "Apprenez à utiliser le mode dictée pour convertir votre discours en texte en mains libres.",
            "welcome": {
                "title": "Dictée",
                "description": "La dictée vous permet de parler naturellement et de saisir vos mots pendant que vous parlez. C'est comme avoir un assistant personnel qui saisit tout ce que vous dites."
            },
            "microphone": {
                "title": "Allumez votre microphone",
                "description": "Tout d'abord, activez votre microphone. Cliquez sur l'icône « Microphone » dans le panneau Cephable."
            },
            "activate": {
                "title": "Démarrer le mode dictée",
                "description": "La voix démarre en mode commande. Pour lancer la dictée, dites « Démarrer la dictée » ou cliquez sur le bouton « Dictée ». Activons maintenant le mode dictée."
            },
            "speaking": {
                "title": "Cliquez sur un document ou un champ et commencez à parler",
                "description": "La dictée enregistre en temps réel ce que vous dites. Cliquez sur un champ de texte ou un document, puis commencez à parler. Par exemple, dites : « Voici comment utiliser le mode dictée. »"
            },
            "pauseResume": {
                "title": "Pause de la dictée",
                "description": "Besoin d'une pause sans désactiver la dictée ? Dites simplement « Suspendre la dictée ». Vous pouvez la reprendre à tout moment avec « Démarrer la dictée ». Vous pouvez personnaliser davantage cette option grâce aux commandes globales et aux commandes de l'appareil toujours actives."
            },
            "stop": {
                "title": "Arrêter la dictée",
                "description": "Besoin de revenir aux commandes de votre application ? Dites simplement « Arrêter la dictée ». Cela arrêtera le mode dictée et vous ramènera au mode commande. Vous pouvez reprendre à tout moment en cliquant à nouveau sur « Démarrer la dictée »."
            },
            "complete": {
                "title": "Bravo!",
                "description": "Et voilà ! Vous pouvez désormais dicter, mettre en pause, reprendre et passer du mode dictée au mode commande. La dictée est un outil puissant pour la saisie mains libres. Utilisez-la pour rédiger des e-mails, des documents ou tout ce que vous devez saisir à voix haute."
            }
        },
        "description": "La dictée vous permet de parler naturellement et de saisir vos mots pendant que vous parlez. C'est comme avoir un assistant personnel qui saisit tout ce que vous dites."
    },
    "face": {
        "title": "Expression du visage",
        "titlePlural": "Expressions du visage",
        "try": "Essayez les contrôles d'expression du visage",
        "question": "Quel type d’expression de visage souhaitez-vous utiliser ?",
        "descriptionShort": "Utilisez différents mouvements du visage pour des contrôles améliorés.",
        "description": "Les expressions faciales font partie des Contrôles d'expression. Elles vous permettent d'utiliser différents mouvements du visage pour des contrôles améliorés. Vous pouvez utiliser les mouvements des sourcils, de la bouche, etc. pour créer différents rendus."
    },
    "other": {
        "title": "Autre",
        "titlePlural": "Autres contrôles",
        "label": "Autre contrôle",
        "placeholder": "autre commande expérimentale",
        "question": "Quelle commande supplémentaire souhaitez-vous utiliser ? Ces commandes sont généralement destinées aux connexions non Cephable qui ne correspondent pas aux autres catégories. Elles peuvent également fonctionner comme des commandes vocales lorsque vous prononcez le mot ou la phrase spécifié. Remarque : ces commandes sont expérimentales et peuvent ne pas être entièrement prises en charge.",
        "description": "Les autres commandes sont expérimentales et peuvent ne pas être entièrement prises en charge. Elles peuvent être utilisées pour des connexions non Cephable ou comme commandes vocales lorsque vous prononcez le mot ou la phrase spécifié."
    },
    "support": {
        "title": "Soutien",
        "profiles": "Introduction aux contrôles d'application",
        "question": "Vous ne trouvez toujours pas ce dont vous avez besoin ?",
        "more": "Apprenez-en plus sur Cephable.com avec des guides étape par étape, des tutoriels, des vidéos et plus encore."
    },
    "community": {
        "title": "Rejoignez la communauté",
        "description": "Obtenez du soutien, partagez des idées ou devenez membre des communautés Cephable.",
        "discord": "Communauté Discorde",
        "facebook": "Groupe Facebook"
    },
    "resources": {
        "title": "Ressources utiles",
        "description": "Trouvez les réponses à vos questions sur les caractéristiques et fonctions de Cephable.",
        "guides": "Guides étape par étape"
    },
    "feedback": {
        "title": "Retour",
        "description": "Parlez-nous de votre expérience avec Cephable.",
        "contact": "Contactez-nous",
        "feature": "Suggérer une fonctionnalité",
        "bug": "Signaler un problème"
    },
    "settings": {
        "title": "Paramètres",
        "general": "Paramètres généraux de l'application",
        "description": "Il s'agit de votre canevas pour personnaliser votre expérience en affinant vos commandes.",
        "orgTitle": "Paramètres de {{ value }}"
    },
    "account": {
        "title": "Compte",
        "settings": "Paramètres du compte",
        "description": "Mettez à jour les informations clés pour rester connecté avec Cephable.",
        "usernameLabel": "Nom d'utilisateur: ",
        "emailLabel": "E-mail: ",
        "password": {
            "change": "Changer le mot de passe",
            "description": "Mettez à jour votre mot de passe pour sécuriser votre compte.",
            "old": "ancien mot de passe",
            "current": "Votre mot de passe actuel",
            "new": "nouveau mot de passe",
            "desired": "Votre nouveau mot de passe souhaité",
            "confirm": "Confirmer le nouveau mot de passe",
            "update": "Mettre à jour le mot de passe"
        },
        "isEmailVerified": {
            "title": "L'email n'est pas verifié.",
            "description": "Votre email n'est pas vérifié. Veuillez vérifier votre courrier électronique pour un lien de vérification.",
            "resend": "Ré-envoyer l'email",
            "success": "Nous vous avons envoyé un nouvel e-mail de vérification.",
            "error": "Une erreur s'est produite lors de l'envoi de l'e-mail de vérification. Veuillez réessayer plus tard.",
            "org": "Votre adresse e-mail n'est pas vérifiée. Elle est requise pour accéder aux informations de la licence. Veuillez consulter votre adresse e-mail pour obtenir un lien de vérification.",
            "titleAlt": "Vérifiez votre adresse e-mail",
            "descriptionLong": "Bienvenue sur Cephable ! Un e-mail de vérification a été envoyé à {{email}}. Veuillez vérifier votre boîte de réception ou votre dossier spam et cliquer sur le lien. Si vous ne le voyez pas, vous pouvez renvoyer l'e-mail de vérification.",
            "appBlock": "Vous y êtes presque ! Un e-mail de vérification a été envoyé à {{email}}. Veuillez consulter votre boîte de réception et cliquer sur le lien pour vérifier votre adresse e-mail. Si vous ne le voyez pas, vérifiez vos spams."
        },
        "signout": {
            "title": "Se déconnecter",
            "question": "Êtes-vous certain de vouloir vous déconnecter?",
            "confirm": "Oui, déconnectez-vous",
            "warn": {
                "title": "Vous êtes sur le point d’être déconnecté.",
                "description": "Il semblerait que vous ayez été inactif pendant un certain temps. Pour des raisons de sécurité, nous vous déconnecterons dans XX secondes. Si vous souhaitez rester connecté, cliquez sur « Rester connecté » ci-dessous.",
                "confirm": "Rester connecté",
                "cancel": "Déconnectez-vous maintenant"
            },
            "description": "Une fois déconnecté, cette connexion sera supprimée de votre compte et ne sera plus visible depuis l'application Companion ou d'autres connexions.",
            "confirmDescription": "Vous déconnecter et supprimer cette connexion"
        },
        "marketing": {
            "title": "Préférences de messagerie",
            "description": "Mettez à jour vos préférences de messagerie pour recevoir des mises à jour et des nouvelles de Cephable.",
            "marketing": "E-mails marketing",
            "optIn": "Je souhaite recevoir des tutoriels, des conseils, des mises à jour et des newsletters pour améliorer mon expérience Cephable"
        },
        "error": {
            "save": "Erreur lors de l'enregistrement des paramètres du compte.",
            "password": "Erreur lors de la mise à jour du mot de passe.",
            "signout": "Erreur de déconnexion.",
            "old": "L'ancien mot de passe est requis.",
            "new": "Un nouveau mot de passe est requis.",
            "match": "Les mots de passe ne correspondent pas.",
            "marketing": "Erreur lors de la mise à jour des préférences de messagerie.",
            "userPreferences": "Erreur lors de l'enregistrement des préférences utilisateur."
        },
        "success": {
            "save": "Paramètres du compte enregistrés.",
            "password": "Mot de passe mis à jour.",
            "marketing": "Préférences de courrier électronique mises à jour.",
            "userPreferences": "Préférences utilisateur mises à jour."
        },
        "userPreferences": {
            "title": "Préférences de l'utilisateur",
            "description": "Mettez à jour vos préférences pour créer l'expérience Cephable qui vous convient.",
            "warningOptOut": "Masquer les avertissements lorsque j'enregistre ou mets à jour les contrôles de l'application",
            "enableTranscribeTask": "Activer la tâche de transcription de fichiers expérimentaux dans le panneau Cephable",
            "enableClickByName": "Windows uniquement. Activez la fonctionnalité expérimentale « Appuyer sur un élément de l’écran par son nom », par exemple « Appuyer sur Enregistrer » pour cliquer sur un bouton nommé « Enregistrer ».",
            "enableGamepadSupport": "Activer la prise en charge de la manette pour le pilote local et l'émulation du contrôleur Xbox",
            "enableMetrics": "Activez la sortie des métriques d'utilisation pour les tests de performance. Vous pourrez télécharger les journaux depuis le panneau Cephable."
        },
        "menu": "Menu utilisateur"
    },
    "appSettings": {
        "description": "Ces paramètres s'appliquent uniquement à cette application. Si vous souhaitez modifier les paramètres de l'application Cephable sur un autre ordinateur ou appareil mobile, modifiez les paramètres dans cette application.",
        "autostart": {
            "title": "Démarrer automatiquement Cephable",
            "description": "Avec ce paramètre activé, l'application Cephable démarrera automatiquement lorsque vous vous connecterez à votre appareil. Si vous disposez également de commandes automatiques de voix et d’expression, celles-ci démarreront également immédiatement.",
            "question": "Démarrage automatique de l'application Cephable ?"
        },
        "position": {
            "topLeft": "En haut à gauche",
            "top": "Centre supérieur",
            "topRight": "En haut à droite",
            "bottom": "En bas au centre",
            "bottomLeft": "En bas à gauche",
            "bottomRight": "En bas à droite",
            "label": "Sélectionner la position d'alimentation de commande",
            "description": "Sélectionnez l’endroit où vous souhaitez que le flux de commandes apparaisse sur votre écran."
        },
        "micPosition": {
            "title": "Position de la fenêtre d'entrée du microphone",
            "description": "Sélectionnez l'endroit où vous souhaitez que les commandes du microphone pour la voix et la dictée soient positionnées sur votre écran.",
            "label": "Sélectionnez la position de la fenêtre d’entrée du microphone"
        },
        "cameraPosition": {
            "title": "Position de la fenêtre d'entrée de la caméra",
            "description": "Sélectionnez l'endroit où vous souhaitez que les commandes de la caméra pour les mouvements du visage et de la tête soient positionnées sur votre écran.",
            "label": "Sélectionner la position de la fenêtre d'entrée de la caméra"
        },
        "theme": {
            "title": "Thème",
            "description": "Choisissez un thème qui correspond à votre style.",
            "label": "Sélectionnez un thème",
            "light": "Lumière",
            "dark": "Sombre",
            "system": "Utiliser les paramètres du système d'exploitation"
        },
        "overlay": {
            "title": "Flux de commandes",
            "description": "Le flux de commandes affiche les différentes commandes que vous utilisez et celles envoyées à votre ordinateur. Il est accessible par clic, mais il est toujours visible par-dessus les autres fenêtres. Lorsque ce paramètre est activé, l'application Cephable s'affiche et est toujours visible par-dessus les autres fenêtres et applications.",
            "question": "Afficher le flux de commandes ?"
        },
        "transparent": {
            "title": "Transparence du flux de commandes",
            "description": "Détermine l'opacité du texte. Plus la valeur est faible, plus le flux sera transparent."
        },
        "panelAutoHide": {
            "title": "Masquer automatiquement le panneau Cephable",
            "delay": "Attendre avant de se cacher",
            "denominator": "secondes",
            "time": "{{value}} secondes"
        },
        "title": "Paramètres généraux de l'application"
    },
    "input": {
        "title": "Saisir",
        "titlePlural": "Contrôles d'entrée",
        "explore": "Explorer les contrôles de saisie",
        "descriptionShort": "Explorez les différents contrôles d'entrée utilisés par Cephable pour créer une meilleure expérience numérique pour vous.",
        "typeLabel": "Type de contrôle d'entrée",
        "toolTip": "Cela utilise {{alt}}",
        "remove": "Supprimer le contrôle d'entrée",
        "filter": "Filtrer par type d'entrée",
        "select": "Sélectionnez une entrée",
        "question": "Quel type d'entrée souhaitez-vous utiliser ?",
        "add": "Ajouter une entrée",
        "addMore": "Ajouter une autre entrée",
        "removeItem": "Supprimer l'élément {{index}}",
        "item": "Article {{index}} : {{label}}",
        "duplicate": "Les articles en double ne sont pas autorisés.",
        "maximum": "Maximum de {{maxItems}} éléments autorisés.",
        "description": "Les commandes d'entrée sont les différentes méthodes utilisées pour contrôler votre appareil. Elles incluent votre voix, les mouvements de la tête, les expressions faciales et d'autres connexions. Explorez les différentes commandes d'entrée ci-dessous pour en savoir plus."
    },
    "time": {
        "soon": "À venir",
        "now": "Maintenant",
        "today": "Aujourd'hui",
        "yesterday": "Hier",
        "minutesAgo": "il y a {{count}} minute",
        "minutesAgo_plural": "il y a {{count}} minutes",
        "daysAgo": "Il y a {{count}} jours",
        "daysAgo_plural": "il y a {{count}} jours",
        "monthsAgo": "il y a {{count}} mois",
        "monthsAgo_plural": "il y a {{count}} mois",
        "yearsAgo": "Il y a {{count}} an",
        "yearsAgo_plural": "il y a {{count}} ans",
        "minutesAhead": "dans {{count}} minutes",
        "todayAhead": "plus tard aujourd'hui",
        "tomorrow": "demain",
        "daysAhead": "dans {{count}} jours",
        "monthsAhead": "dans {{count}} mois",
        "yearsAhead": "dans {{count}} ans"
    },
    "peripherals": {
        "empty": "Aucun périphérique détecté",
        "switch": "Changer",
        "keyboard": "Clavier",
        "gamepad": "Manette de jeu",
        "companionApp": "Application compagnon",
        "available": "disponible à l'emploi",
        "error": "Vérifiez vos paramètres."
    },
    "camera": {
        "windowTitle": "Commandes de caméra céphable",
        "title": "Caméra",
        "titlePlural": "Appareils photo",
        "settings": "Les paramètres de la caméra",
        "start": "Démarrer la caméra",
        "restart": "Redémarrer la caméra",
        "descriptionShort": "Permet l'expression du visage et le mouvement de la tête.",
        "description": "Utilisez votre appareil photo pour détecter les expressions du visage et les gestes du corps comme différentes commandes.",
        "empty": "Aucune caméra trouvée.",
        "search": "Rechercher par nom de caméra",
        "loading": "Chargement des commandes de la caméra...",
        "error": "Erreur inattendue lors du chargement des commandes de la caméra. Veuillez vérifier votre caméra et réessayer.",
        "manage": {
            "title": "Cliquez pour afficher et gérer les détails de vos caméras.",
            "description": ""
        },
        "detected": {
            "face": "Visage détecté.",
            "noFace": "Aucun visage détecté. Veuillez ajuster votre caméra ou votre position et réessayer.",
            "command": "Détecté : {{commande}}"
        },
        "permission": {
            "title": "Autorisations de caméra requises",
            "description": "Vous devez autoriser Cephable à utiliser votre appareil photo pour utiliser les commandes du visage et du corps.",
            "button": "Paramètres d'autorisation d'ouverture",
            "no": "Pas d'accès à la caméra",
            "help": "Cephable a besoin d&#39;accéder à votre caméra pour utiliser les commandes d&#39;expression et de tête. Accédez à <strong>Paramètres système</strong>  <strong>Confidentialité</strong>  <strong>Caméra</strong> et activez Cephable pour accéder à votre caméra."
        },
        "controls": {
            "startData": "J'ai commencé à enregistrer les données du visage. Appuyez à nouveau sur le raccourci dans la fenêtre de l'appareil photo pour arrêter l'enregistrement et le téléchargement.",
            "downloadData": "Enregistrement arrêté, téléchargement de données",
            "paused": "Commandes de caméra suspendues.",
            "pause": "Suspendre les commandes de la caméra",
            "resume": "Reprendre les commandes de la caméra",
            "resumed": "Reprise des contrôles de la caméra.",
            "linesOn": "Activer les lignes du visage",
            "linesOff": "Désactiver les lignes du visage",
            "linesToggle": "Activer/désactiver le dessin des lignes du visage",
            "noDeviceTitle": "Aucune caméra détectée pouvant être utilisée avec Cephable.",
            "noDeviceDescription": "Vous devez connecter une caméra compatible avec les applications mobiles.",
            "noDeviceConnectedDescription": "Le contrôle de la caméra sert d'aperçu de l'interface. Aucune étape ne sera exécutée avec succès. Connectez cet appareil compagnon à un autre, afin de lancer des commandes.",
            "lines": "Lignes du visage"
        },
        "switch": {
            "title": "Changer de caméra",
            "description": "Sélectionnez une autre caméra à utiliser pour les commandes du visage et du corps.",
            "select": "Sélectionnez la caméra",
            "next": "Caméra suivante",
            "nextLong": "Passer à la caméra suivante",
            "empty": "Aucune autre caméra trouvée.",
            "search": "Rechercher par nom de caméra"
        },
        "baseline": {
            "title": "Référence",
            "description": "La ligne de base est la position par défaut de votre visage et de votre corps que Cephable utilise pour déterminer vos mouvements. Vous pouvez mettre à jour et réinitialiser la ligne de base ici.",
            "update": "Mettre à jour la référence",
            "reset": "Réinitialiser la ligne de base",
            "updated": "Base de référence mise à jour",
            "tooltip": "Cliquez pour mettre à jour votre ligne de base vers votre position de repos actuelle."
        },
        "edit": {
            "title": "Modifier les paramètres de la caméra",
            "description": "Vous pouvez affiner les paramètres de vos entrées nécessitant une caméra pour mieux répondre à vos besoins.",
            "autoStart": {
                "title": "Démarrer automatiquement la caméra",
                "option": "Démarrage automatique de la caméra et des commandes de tête/expression ?",
                "description": "Lorsque ce paramètre est activé, votre manette activera votre caméra, vous permettant d'utiliser les expressions faciales et les mouvements de la tête dès le démarrage de l'application. Si ce paramètre est désactivé, appuyez sur le bouton « Démarrer la caméra » sur votre page de connexion."
            },
            "head": {
                "title": "Sensibilité aux mouvements de la tête",
                "description": "La sensibilité indique à Cephable jusqu'où vous devez vous déplacer pour déclencher un contrôle. Plus la valeur est grande (la plus à droite du curseur), plus la sensibilité est élevée, et donc moins vous aurez besoin de vous déplacer pour déclencher la commande.",
                "tilt": {
                    "title": "Sensibilité à l'inclinaison de la tête",
                    "description": "Ces valeurs déterminent jusqu'où vous devez incliner la tête vers le haut, le bas, la gauche et la droite pour déclencher les commandes.",
                    "up": "Sensibilité à l'inclinaison",
                    "down": "Sensibilité d'inclinaison vers le bas",
                    "left": "Sensibilité d'inclinaison à gauche",
                    "right": "Sensibilité d'inclinaison à droite",
                    "scaleHigh": "Légère inclinaison",
                    "scaleLow": "Grande inclinaison"
                },
                "turn": {
                    "title": "Sensibilité au tour de tête",
                    "description": "Ces valeurs déterminent jusqu'où vous devez tourner la tête vers la gauche et la droite pour déclencher les commandes.",
                    "left": "Tourner à gauche Sensibilité",
                    "right": "Tourner à droite Sensibilité",
                    "scaleHigh": "Léger virage",
                    "scaleLow": "Grand virage"
                },
                "lean": {
                    "title": "Sensibilité de la tête maigre",
                    "description": "Ces valeurs déterminent jusqu'où vous devez pencher la tête en avant et en arrière pour déclencher les commandes.",
                    "forward": "Sensibilité à se pencher vers l’avant",
                    "back": "Sensibilité à se pencher en arrière",
                    "right": "Sensibilité maigre à droite",
                    "left": "Sensibilité maigre à gauche",
                    "scaleHigh": "Légèrement penché",
                    "scaleLow": "Grand maigre"
                },
                "duck": {
                    "title": "Sensibilité tête canard/montée",
                    "description": "Ces valeurs déterminent jusqu'où vous devez baisser ou relever la tête pour déclencher les commandes.",
                    "down": "Sensibilité au duvet de canard",
                    "up": "Augmentez la sensibilité",
                    "scaleHigh": "Léger décalage",
                    "scaleLow": "Grand changement"
                }
            },
            "face": {
                "title": "Sensibilité à l'expression du visage",
                "description": "La sensibilité indique à Cephable à quel point une expression est exagérée dont vous avez besoin pour déclencher un contrôle. Plus la valeur est grande (la plus à droite du curseur), plus la sensibilité est élevée, et donc moins vous aurez besoin de vous déplacer pour déclencher la commande.",
                "eyebrow": {
                    "title": "Sensibilité des sourcils",
                    "description": "Ces valeurs déterminent jusqu'où vous devez lever ou baisser vos sourcils pour déclencher les commandes.",
                    "up": "Augmenter la sensibilité des sourcils",
                    "scaleHigh": "Légère augmentation",
                    "scaleLow": "Augmentation importante"
                },
                "mouth": {
                    "title": "Sensibilité buccale",
                    "description": "Ces valeurs déterminent jusqu'où vous devez ouvrir ou fermer la bouche pour déclencher les commandes.",
                    "open": "Sensibilité à la bouche ouverte",
                    "close": "Sensibilité de la bouche fermée",
                    "smile": "Sensibilité du sourire",
                    "scaleHigh": "Légèrement ouvert",
                    "scaleLow": "Grand Ouvert",
                    "closeScaleHigh": "Légèrement fermé",
                    "closeScaleLow": "Bien fermé",
                    "smileScaleHigh": "Léger sourire",
                    "smileScaleLow": "Grand sourire"
                }
            },
            "mouse": {
                "title": "Mouvement de la tête pour les commandes de la souris",
                "description": "Déterminez si et comment vous souhaitez utiliser les commandes de mouvements de la tête pour déplacer votre souris au lieu de déclencher d'autres sorties.",
                "enable": {
                    "title": "Activer le mouvement de la tête pour les commandes de la souris",
                    "description": "Si cette option est activée, certaines de vos commandes de mouvement de la tête seront utilisées pour déplacer votre souris au lieu des commandes de déclenchement.",
                    "option": "Utiliser les commandes de la tête pour le mouvement de la souris ?"
                },
                "input": {
                    "title": "Type d'entrée de la souris",
                    "description": "Sélectionnez le type de gestes de la tête que vous souhaitez attribuer aux commandes de la souris. Par exemple, Head Tilting signifie que vous pouvez incliner votre tête vers la gauche et la droite pour déplacer votre souris vers la gauche et la droite, Head Turning signifie que vous pouvez tourner la tête vers la gauche et la droite pour déplacer votre souris et Head Leaning signifie que vous pouvez vous pencher vers la gauche et la droite pour bouger. votre souris.",
                    "option": "Sélectionnez le type d'entrée",
                    "optionLong": "Sélectionnez le type de mouvement de tête que vous souhaitez utiliser pour contrôler votre souris."
                },
                "invert": {
                    "title": "Inverser le mouvement de la souris",
                    "description": "Si cette option est activée, la direction dans laquelle vous déplacez votre tête sera inversée par rapport à la direction dans laquelle votre souris se déplace. Pour l'axe X : si cette option est activée, un déplacement vers la gauche déplacera votre souris vers la droite et un déplacement vers la droite la déplacera vers la gauche. Pour l'axe Y : si cette option est activée, le fait de descendre déplacera votre souris vers le haut et le fait de monter la fera descendre.",
                    "x": "Inverser le mouvement de la souris sur l'axe X ?",
                    "y": "Inverser le mouvement de la souris sur l'axe Y ?"
                },
                "mode": {
                    "title": "Mode de déplacement de la souris",
                    "description": "Sélectionnez la manière dont vous souhaitez que le curseur réagisse aux mouvements de votre tête."
                },
                "speed": {
                    "title": "Vitesse de la souris",
                    "description": "Déterminez la vitesse constante à laquelle vous souhaitez que le curseur se déplace.",
                    "fast": "Rapide",
                    "slow": "Lent"
                },
                "linear": {
                    "title": "Mouvement linéaire de la souris",
                    "description": "Si cette option est activée, le curseur se déplace uniquement en lignes droites horizontales ou verticales, ce qui facilite la navigation dans ces directions spécifiques sans aucune dérive diagonale.",
                    "option": "Utiliser le mouvement linéaire de la souris ?"
                },
                "accelerationRate": {
                    "title": "Taux d'accélération de la souris",
                    "description": "Ajustez la vitesse à laquelle le curseur accélère au fur et à mesure que vous maintenez votre tête immobile."
                },
                "accelerationCurve": {
                    "title": "Courbe d'accélération de la souris",
                    "description": "Ajustez la vitesse à laquelle la vitesse du curseur augmente par rapport au mouvement de la tête.",
                    "linear": "Linéaire",
                    "exponential": "Exponentiel",
                    "sublinear": "Sous-linéaire"
                },
                "maximumSpeed": {
                    "title": "Vitesse maximale de la souris",
                    "description": "Déterminez le nombre maximal de pixels que le curseur peut déplacer par seconde."
                },
                "steadyGlide": {
                    "title": "Glisse stable",
                    "description": "Lorsque vous déplacez votre tête au-delà d’un certain point, le curseur glisse continuellement dans cette direction à une vitesse constante."
                },
                "speedBoost": {
                    "title": "Augmentation de la vitesse",
                    "description": "Le curseur commence à se déplacer plus rapidement à mesure que vous gardez la tête dans la même position. Plus vous gardez la tête immobile longtemps, plus le curseur accélère rapidement."
                },
                "dynamicGlide": {
                    "title": "Glisse dynamique",
                    "description": "La vitesse du curseur augmente en fonction de la distance à laquelle vous bougez la tête. Plus vous bougez la tête, plus le curseur glisse vite."
                },
                "proportionalSpeed": {
                    "title": "Vitesse proportionnelle",
                    "description": "Le curseur suit le bout de votre nez proportionnellement aux dimensions de votre écran."
                },
                "off": {
                    "title": "Désactivé",
                    "description": "Le mouvement de la souris est désactivé."
                }
            }
        },
        "stop": "Arrêter la caméra",
        "show": "Afficher la caméra",
        "hide": "Masquer la caméra",
        "warn": "Les commandes de la caméra n'ont pas été démarrées, démarrez votre caméra pour autoriser les commandes du visage et du corps.",
        "draw": {
            "error": "Erreur lors du chargement du flux de la caméra. Veuillez vérifier votre caméra et réessayer."
        },
        "select": "Sélectionnez une caméra avec laquelle vous souhaitez vous associer pour des commandes améliorées à l'aide de votre visage, de votre corps et des boutons d'action rapide."
    },
    "microphone": {
        "windowTitle": "Commandes vocales céphables",
        "title": "Microphone",
        "titlePlural": "Micros",
        "settings": "Paramètres du microphone",
        "start": "Démarrer le microphone",
        "stop": "Arrêter le microphone",
        "descriptionShort": "Permet les commandes vocales et la dictée.",
        "description": "Utilisez votre microphone intégré pour activer les commandes vocales et la dictée.",
        "select": "Sélectionnez un microphone avec lequel vous souhaitez vous associer pour des commandes améliorées à l'aide de votre voix.",
        "empty": "Aucun microphone trouvé.",
        "search": "Rechercher par nom de microphone",
        "manage": {
            "title": "Cliquez pour afficher et gérer les détails de vos microphones.",
            "description": ""
        },
        "permission": {
            "title": "Autorisations de microphone requises",
            "description": "Vous devez autoriser Cephable à utiliser votre microphone pour utiliser les commandes vocales.",
            "button": "Paramètres d'autorisation d'ouverture",
            "no": "Pas d'accès au microphone",
            "help": "Cephable a besoin d&#39;accéder à votre microphone pour utiliser les commandes vocales. Accédez à <strong>Paramètres système</strong>  <strong>Confidentialité</strong>  <strong>Microphone</strong> et activez Cephable pour accéder à votre microphone."
        },
        "controls": {
            "pause": "Suspendre les commandes vocales",
            "paused": "Contrôles suspendus.",
            "resume": "Reprendre les commandes vocales",
            "dictationPlay": "Démarrer le mode dictée",
            "dictationPause": "Arrêter le mode dictée",
            "prompt": "Commencez à parler pour voir vos commandes vocales ici...",
            "dictationPrompt": "Commencez à parler pour taper ce que vous dites...",
            "latency": "Latence élevée détectée. Pensez à fermer certaines applications susceptibles de consommer trop de ressources.",
            "noDeviceConnectedDescription": "Le contrôle du microphone sert d'aperçu de l'interface. Aucune étape ne sera exécutée avec succès. Connectez cet appareil compagnon à un autre, afin de lancer des commandes.",
            "status": {
                "paused": "En pause.",
                "dictating": "Dicter.",
                "optimistic": "Optimiste:",
                "listening": "Écoute:",
                "loadingModel": "Chargement du modèle vocal...",
                "thinking": "Pensée...",
                "loadingPhiModel": "Chargement du modèle de génération de texte...",
                "generatingText": "Générateur...",
                "preparingPhiModel": "Préparation du modèle de génération de texte...",
                "permission": "Vérification des autorisations du microphone...",
                "typing": "Dactylographie..."
            },
            "loadingDetail": "Cela peut prendre quelques minutes.",
            "generatingTextDetail": "Arrêtez la génération en changeant d'application ou en disant « arrêtez de générer »"
        },
        "edit": {
            "title": "Modifier les paramètres du microphone",
            "autoStart": {
                "title": "Démarrer automatiquement le microphone",
                "option": "Microphone à démarrage automatique et commandes vocales ?",
                "description": "Lorsque ce paramètre est activé, votre périphérique d'entrée activera les microphones et commencera à traiter les commandes vocales dès son démarrage, après l'avoir branché ou allumé. Si ce paramètre est désactivé, vous devez appuyer sur le bouton « Commencer l'écoute » dans votre page de connexion."
            },
            "optimistic": {
                "title": "Commandes vocales optimistes",
                "option": "Utiliser les commandes vocales optimistes ?",
                "description": "Cephable propose deux modes de sensibilité différents pour les commandes vocales : Standard et Optimiste. Le mode Standard permet à Cephable de reconnaître tous les mots qu'il comprend et peut être utilisé avec le mode dictée. Le mode Optimiste indique à Cephable de se concentrer davantage sur les commandes vocales dans les commandes de votre application. Avec le mode Optimiste activé, vos commandes vocales se déclenchent plus rapidement, mais vous pouvez également déclencher accidentellement votre commande si vous ne prononcez pas le mot exact. Le mode Optimiste ne permet pas la dictée."
            },
            "confirm": {
                "title": "Vous avez des changements non enregistrés.",
                "description": "Modifications non enregistrées détectées. Souhaitez-vous enregistrer avant de quitter ?"
            },
            "aiCommands": {
                "title": "Commandes vocales intelligentes",
                "description": "Grâce aux commandes vocales intelligentes, l'IA de Cephable prédit les commandes vocales que vous essayez d'utiliser sans avoir à les reproduire exactement. Vous pouvez ainsi indiquer plus naturellement à votre ordinateur ce qu'il doit faire, et Cephable vous aide à le comprendre.",
                "option": "Utiliser des commandes vocales intelligentes ?"
            },
            "aiDictation": {
                "title": "Dictée intelligente et saisie rapide",
                "description": "La dictée intelligente et la saisie rapide offrent l'expérience de saisie la plus précise sur appareil. La dictée gère automatiquement la ponctuation, les noms propres et la structure des phrases, tandis que la saisie rapide propose des prédictions et des corrections intelligentes pour une écriture facile et précise.",
                "option": "Utiliser la dictée intelligente et la saisie rapide ?"
            },
            "description": "Gérez vos commandes vocales et vos paramètres de dictée pour cette connexion."
        },
        "warn": "Votre microphone n'est pas activé. Activez-le pour autoriser les commandes vocales et la dictée.",
        "devices": {
            "error": "Périphérique d'entrée du microphone introuvable."
        },
        "startDescription": "Allumez le microphone pour commencer à écouter les commandes."
    },
    "localization": {
        "title": "Paramètres de langue",
        "titleShort": "Langue",
        "description": "Choisissez votre langue préférée dans une liste de langues prises en charge.",
        "newUserDescription": "Veuillez sélectionner une langue préférée avant de continuer.",
        "edit": "Modifier les préférences",
        "display": {
            "title": "Langue d'affichage",
            "description": "Langue d'affichage lors de l'utilisation de Cephable. Cela inclut les menus, les notifications et les commandes des applications, affichés dans la langue de votre choix."
        },
        "voice": {
            "title": "Langue de commande vocale",
            "description": "C'est la langue utilisée lors de la reconnaissance des dictées et des commandes vocales. La spécification de la langue améliore la précision de vos saisies vocales.",
            "settings": {
                "title": "Reconnaissance vocale et langue d'affichage",
                "description": "Ajustez vos paramètres de langue pour l'affichage et les commandes vocales. Cette option vous permet de sélectionner vos langues préférées pour le texte à l'écran et les interactions avec le microphone, comme les commandes vocales et la dictée."
            }
        },
        "locales": {
            "en": "English - Anglais",
            "en-us": "English (US) - Anglais (États-Unis)",
            "es": "Español - Espagnol",
            "fr": "Français",
            "it": "Italiano — Italien",
            "de": "Deutsch - Allemand",
            "ja": "日本語 - Japonais"
        },
        "save": {
            "success": "Préférences locales de l'utilisateur enregistrées !",
            "error": "Erreur lors de l'enregistrement des préférences de paramètres régionaux de l'utilisateur"
        }
    },
    "mobileApp": {
        "title": "Application mobile"
    },
    "skipToMain": "Accéder au Contenu Principal",
    "dashboard": {
        "title": "Tableau de bord"
    },
    "developer": {
        "title": "Promoteur",
        "titleLong": "Ressources pour les développeurs",
        "description": "Cephable peut être intégré directement dans votre application, jeu ou service à l'aide de nos SDK.",
        "sdk": {
            "title": "Découvrez nos SDK",
            "description": "Nous fournissons des SDK de premier ordre conçus pour intégrer de manière transparente la reconnaissance vocale et les contrôles adaptatifs dans vos applications. Nos outils sont conçus pour améliorer l'interaction des utilisateurs grâce à des commandes intuitives et pour favoriser l'accessibilité, garantissant ainsi que votre logiciel peut être utilisé plus efficacement par tous les utilisateurs.",
            "javascript": {
                "title": "JavaScript",
                "subtitle": "Web",
                "description": "Intégrez les commandes vocales et adaptatives directement dans vos applications Web.",
                "action": "Obtenir le Package NPM"
            },
            "net": {
                "title": ".NET",
                "subtitle": "Applications Windows",
                "description": "Exploitez la puissance de .NET pour créer des applications avec nos SDK WPF et WinUI3.",
                "actionCore": "Obtenez le Package de base",
                "actionWpf": "Obtenir le Package WPF"
            },
            "android": {
                "title": "Androïde",
                "subtitle": "Appareils mobiles",
                "description": "Applications Android conçues pour faciliter les capacités de voix et de mouvement de la tête.",
                "action": "Obtenir le SDK Android"
            },
            "more": {
                "title": "Plus",
                "description": "Vous ne trouvez pas ce que vous cherchez ? Contactez-nous et nous pourrons vous aider.",
                "action": "Demander un SDK"
            }
        },
        "demo": {
            "title": "Démos",
            "titleLong": "Découvrez nos SDK en action",
            "description": "Découvrez la puissance de nos technologies de contrôle de la voix et des mouvements de la tête grâce à nos exemples d'applications. Des jeux interactifs aux applications Web et mobiles dynamiques, chaque exemple démontre la polyvalence et l'efficacité de nos SDK. Explorez ces exemples pour obtenir des informations et des idées pour intégrer une accessibilité améliorée et des expériences immersives dans vos propres projets.",
            "game": {
                "title": "Jeu 2048",
                "subtitle": "Web",
                "description": "Améliorez le gameplay traditionnel avec des commandes adaptatives de voix et de mouvement de la tête.",
                "action": "Jouer le jeu"
            },
            "unity": {
                "title": "Unité",
                "subtitle": "Développement de jeux",
                "description": "Découvrez comment les commandes adaptatives peuvent être exploitées dans les jeux pour offrir une expérience utilisateur plus attrayante.",
                "action": "Obtenir l'échantillon"
            },
            "samples": "Démos et échantillons",
            "other": {
                "title": "Autres démos",
                "description": "Découvrez de première main comment Cephable peut améliorer votre application, votre jeu ou votre appareil.",
                "action": "Voir plus de démos"
            },
            "web": {
                "title": "Exemples de SDK Web",
                "subtitle": "Web",
                "description": "Intégration simple de toutes nos fonctionnalités principales dans les applications Web.",
                "action": "Découvrez le SDK"
            }
        },
        "other": {
            "title": "Autres ressources",
            "description": "Si vous ne trouvez pas ce dont vous avez besoin dans nos SDK, essayez de travailler directement avec nos API ou contactez la communauté pour obtenir de l'aide, de l'inspiration et du soutien.",
            "api": {
                "title": "API",
                "description": "Nos API vous permettent d'interagir directement avec Cephable. Vous pouvez utiliser nos API pour créer des intégrations personnalisées."
            },
            "support": {
                "title": "Soutien",
                "description": "Vous ne trouvez pas ce que vous cherchez ? Contactez notre communauté via Discord.",
                "action": "Rejoignez Discord"
            }
        }
    },
    "invalidNumber": "N/A",
    "upgrade": "Mise à niveau",
    "license": {
        "trial": {
            "subtitle": "Vous pouvez inviter {{count}} collègues à essayer Cephable avec vous.",
            "noUsersSubtitle": "Il ne vous reste plus d'utilisateurs d'essai. Passez à une licence payante pour ajouter plus d'utilisateurs.",
            "expired": {
                "user": "Votre essai gratuit expire le {{date}}. Pour effectuer une mise à niveau, veuillez contacter votre administrateur - {{admin}}.",
                "admin": "Votre essai gratuit expire le {{date}}.",
                "userLong": "Il semble que votre essai gratuit de Cephable ait expiré. Pour effectuer la mise à niveau, veuillez contacter votre administrateur - {{admin}}.",
                "adminLong": "Il semble que votre essai gratuit de Cephable ait expiré. Veuillez mettre à niveau votre licence pour continuer à utiliser l'application."
            },
            "start": "Commencez un essai gratuit",
            "title": {
                "single": "Vous êtes en période d'essai gratuit avec {{days}} jours restants",
                "multiple": "{{organization}} est en essai gratuit avec {{days}} jours restants"
            },
            "upgrade": "En effectuant une mise à niveau, conservez votre accès à des fonctionnalités telles que les commandes vocales améliorées, les tâches intelligentes de l'IA et de nombreuses commandes d'applications prédéfinies."
        },
        "required": {
            "title": "Une licence professionnelle Cephable est requise",
            "description": "Il semble que vous utilisiez Cephable Basic, qui ne prend pas en charge l'utilisation commerciale de Cephable. Veuillez passer à une licence professionnelle pour continuer à utiliser l'application."
        },
        "upgrade": {
            "professional": "Mise à niveau vers la Licence Professionnelle Cephable",
            "generic": {
                "title": "Améliorez Votre Expérience Cephable",
                "description": "La plateforme Cephable propose différents produits destinés à une utilisation commerciale au travail, à l'école ou intégrés dans des solutions natives."
            },
            "fallback": {
                "title": "Erreur lors du chargement du portail de facturation",
                "description": "Impossible de charger le portail de facturation. Veuillez cliquer sur le bouton ci-dessous pour contacter sales@cephable.com afin de poursuivre la mise à niveau."
            }
        },
        "activate": {
            "question": "Vous avez déjà une clé de licence ?",
            "button": "Activer",
            "title": "Activer la Clé de Licence",
            "description": "Saisissez votre clé de licence pour mettre à niveau Cephable. Si vous n'en avez pas, démarrez un essai gratuit ou achetez une licence.",
            "fieldLabel": "Clé de Licence",
            "placeholder": "NkmurBfZzFrmm9Kx",
            "success": "Félicitations. Votre compte a été mis à niveau vers {{license}} !",
            "invalid": {
                "key": "Clé non valide. Veuillez vous assurer que vous avez saisi la bonne clé.",
                "empty": {
                    "key": "Clé non valide. Veuillez vérifier la valeur saisie.",
                    "name": "Nom d'organisation non valide. Veuillez vérifier la valeur saisie."
                }
            },
            "descriptionLong": "Saisissez votre clé de licence pour mettre à niveau Cephable. Si vous n'en avez pas, démarrez un essai gratuit ou achetez une licence."
        },
        "welcome": {
            "title": "Bienvenue chez {{license}}.",
            "description": "Vous avez rejoint avec succès {{organization}}. {{description}}"
        },
        "redirect": {
            "title": "Redirection",
            "description": "Vous avez été redirigé vers un portail de facturation externe. Cela ouvrira un nouvel onglet dans votre navigateur. Si vous n'êtes pas redirigé dans quelques secondes, veuillez cliquer sur le bouton ci-dessous.",
            "error": "Erreur de redirection de facturation",
            "external": "Redirection effectuée. Veuillez vérifier votre navigateur."
        },
        "key": {
            "title": "Clé de licence",
            "titlePlural": "Clés de licence",
            "description": "Une clé de licence est un identifiant unique utilisé pour accorder l'accès aux fonctionnalités Cephable Professional, Education ou Developer.",
            "details": "Détails de la clé de licence",
            "assigned": "Utilisé le : {{date}}",
            "expires": "Expire le : {{date}}",
            "assign": "Attribuer une clé à une nouvelle organisation",
            "error": "Erreur lors du chargement de la clé de licence.",
            "empty": {
                "title": "Aucune clé de licence trouvée.",
                "description": "Il ne semble pas qu'il existe de clés de licence correspondant à ces critères. Ou vous n'avez pas encore acheté de clé de licence."
            },
            "product": {
                "title": "Achat",
                "titleLong": "Acheter des clés de licence",
                "description": "Achetez une clé de licence pour exploiter tout le potentiel de Cephable. Consultez les différents plans et options de tarification disponibles.",
                "action": "Achetez maintenant",
                "empty": {
                    "title": "Aucun produit trouvé.",
                    "description": "Il semble que vous n'ayez aucun produit. Veuillez contacter notre équipe commerciale ou votre représentant pour vous aider à résoudre ce problème."
                },
                "yearly": "Facturé annuellement",
                "years": "Facturé tous les {{value}} ans",
                "days": "Facturé tous les {{value}} jours",
                "Subscription": {
                    "title": "Abonnement"
                },
                "MeteredConsumption": {
                    "title": "Consommation mesurée"
                },
                "PayDown": {
                    "title": "Payer"
                },
                "OneTime": {
                    "title": "Une fois"
                }
            }
        },
        "pro": {
            "tag": "Pro",
            "detail": "Il s'agit d'une fonctionnalité réservée à Cephable Professional",
            "requiredDetail": "Une licence Cephable Professionnelle est requise pour cette fonctionnalité. Vous pouvez mettre à niveau ou démarrer un essai gratuit dans les paramètres de votre compte."
        },
        "titlePlural": "Licences"
    },
    "purchase": "Achat",
    "saveError": "Erreur lors de l'enregistrement des modifications.",
    "description": "Description",
    "expand": "Développer",
    "expandMenu": "Développer le menu",
    "editor": {
        "title": "Éditeur Markdown",
        "bold": "Audacieux",
        "italic": "Italique",
        "underline": "Souligner",
        "hr": "Règle horizontale",
        "link": "Lien",
        "quote": "Citation",
        "code": "Code",
        "codeBlock": "Bloc de code",
        "comment": "Commentaire",
        "image": "Image",
        "table": "Tableau",
        "unordered-list": "Liste non ordonnée",
        "ordered-list": "Liste ordonnée",
        "checked-list": "Liste de contrôle",
        "help": "Aide",
        "edit": "Modifier",
        "live": "En direct",
        "preview": "Aperçu",
        "fullscreen": "Plein écran",
        "placeholder": "Veuillez saisir le texte Markdown ici...",
        "strikethrough": "Barré"
    },
    "created": "Créé : {{value}}",
    "updated": "Mis à jour : {{value}}",
    "deleted": "Supprimé : {{value}}",
    "expires": "Expire : {{value}}",
    "expired": "Expiré : {{value}}",
    "used": "Utilisé : {{value}}",
    "results": "Résultats",
    "panel": {
        "title": "Panneau Céphable",
        "question": "Panneau de démarrage automatique ?",
        "position": {
            "top": "Haut",
            "right": "Droite",
            "left": "Gauche",
            "bottom": "Bas ",
            "description": "Sélectionnez l'endroit où vous souhaitez que le panneau Cephable apparaisse sur votre écran.",
            "label": "Position"
        },
        "sections": {
            "description": "Choisissez les sections visibles du panneau. Vous pouvez masquer des sections selon vos préférences pour optimiser l'espace du panneau.",
            "microphone": "Microphone et commandes vocales",
            "camera": "Commandes de la caméra et du visage/de la tête",
            "profile": "Contrôles et aperçus de l'application",
            "globalControls": "Contrôles globaux et de périphérique",
            "tasks": "Tâches intelligentes",
            "buttons": "Boutons d'action rapide"
        },
        "titleShort": "Panneau",
        "description": "Il s'agit du panneau qui constitue le centre de contrôle principal. Il est toujours visible et vous permet de contrôler vos applications à la voix, et bien plus encore. Commençons par le microphone."
    },
    "resume": "CV",
    "textGeneration": {
        "settings": "Paramètres de génération de texte",
        "edit": {
            "title": "Modifier les paramètres de génération de texte",
            "description": "Vous pouvez affiner les paramètres de votre génération de texte intelligente pour créer les meilleures sorties pour vous.",
            "autoStart": {
                "title": "Génération automatique de texte de préchauffage",
                "description": "Lorsque ce paramètre est activé, Cephable AI réchauffe automatiquement les modèles d'IA utilisés pour la génération de texte. Cela accélère les performances des modèles lors de l'utilisation des commandes de génération, mais consomme davantage de ressources sur votre ordinateur. Désactiver ce paramètre permet d'économiser des ressources, mais peut ralentir la génération de texte.",
                "option": "Modèles d'IA de génération de texte à préchauffage automatique ?"
            },
            "prompt": {
                "title": "Informations complémentaires pour la génération de texte",
                "description": "Saisissez les informations supplémentaires à utiliser avec l'IA de Cephable pour générer du texte. Utilisez ce champ pour indiquer vos préférences concernant le ton, le style d'écriture ou tout autre détail.",
                "field": "Invite supplémentaire",
                "placeholder": "Par exemple, adoptez un ton amical, écrivez comme un professionnel, soyez concis et direct. Lorsque vous écrivez du code, laissez des commentaires pertinents, mais pas trop nombreux, etc."
            },
            "enableTextGen": {
                "title": "Activer la génération de texte intelligente",
                "description": "Lorsque ce paramètre est activé, Cephable AI peut utiliser le contrôle de génération de texte pour générer du texte dans n'importe quelle application. Désactiver cette option désactive cette commande.",
                "option": "Utiliser la génération de texte intelligente ?"
            },
            "terminate": {
                "title": "Ressources de génération de texte clair",
                "description": "Cliquez pour effacer les ressources utilisées pour la génération de texte. Cela libérera des ressources sur votre ordinateur, mais pourrait ralentir la génération de texte lors de votre prochaine utilisation.",
                "button": "Ressources claires",
                "success": "Effacement des ressources de génération de texte.",
                "confirm": {
                    "title": "Ressources de génération de texte clair",
                    "description": "Voulez-vous vraiment libérer les ressources utilisées pour la génération de texte ? Cela libérera des ressources sur votre ordinateur, mais pourrait ralentir la génération de texte lors de votre prochaine utilisation.",
                    "confirm": "Oui, des ressources claires",
                    "cancel": "Annuler"
                }
            },
            "clearModelCache": {
                "title": "Cache de modèle de génération de texte clair",
                "description": "Cliquez pour vider le cache des modèles d'IA utilisés pour la génération de texte. Cela libérera de l'espace sur votre ordinateur, mais pourrait ralentir la génération de texte lors de votre prochaine utilisation, car Cephable devra retélécharger les fichiers.",
                "button": "Effacer le cache du modèle",
                "success": "Fichiers de modèle locaux supprimés.",
                "confirm": {
                    "title": "Cache de modèle de génération de texte clair",
                    "description": "Voulez-vous vraiment vider le cache des modèles d'IA utilisés pour la génération de texte et supprimer les fichiers de votre système ? Cela ralentira la prochaine fois que vous utiliserez la génération de texte, car Cephable devra retélécharger les fichiers.",
                    "confirm": "Oui, supprimer les fichiers",
                    "cancel": "Annuler"
                },
                "error": "Erreur lors de la suppression des fichiers de modèle locaux."
            },
            "enableHistory": {
                "title": "Activer l'historique de génération de texte",
                "description": "Avec ce paramètre activé, Cephable AI utilisera votre historique de génération de texte pour générer du texte avec le contexte de votre action précédente.",
                "option": "Utiliser l'historique de génération de texte ?"
            }
        },
        "prompt": {
            "systemPrompt": "Vous êtes un assistant générateur de texte utile et vous générerez du texte pour l'utilisateur dans l'application qu'il utilise. Ne fournissez aucun détail, explication ou superflu au texte généré ; contentez-vous de ce qui est demandé. N'utilisez pas de Markdown sauf demande expresse. Si on vous demande de générer du code, ne fournissez pas d'explications sur le code généré ni de symboles Markdown autour du code. Fournissez simplement le contenu généré demandé par l'utilisateur, sans rien d'autre. N'utilisez pas de graduations Markdown ni de langage. Contentez-vous du code ; c'est extrêmement important.",
            "appName": "Vous générez actuellement du texte pour {{appName}}.",
            "userPreferences": "Respectez ces préférences utilisateur quant à la manière dont ils souhaitent que le texte soit généré : {{userPreferences}}."
        },
        "rewritePrompt": {
            "systemPrompt": "Vous êtes un assistant générateur de texte utile et vous générerez du texte pour l'utilisateur dans l'application qu'il utilise. Ne fournissez aucun détail, explication ou élément superflu au texte généré ; contentez-vous de ce qui est demandé. N'utilisez pas de Markdown sauf demande expresse. Si l'on vous demande de générer du code, ne fournissez pas d'explications ni de symboles Markdown autour du code. Fournissez simplement le contenu généré demandé par l'utilisateur, sans rien d'autre. N'utilisez pas de graduations Markdown ni de langage. Contentez-vous du code ; c'est extrêmement important. L'utilisateur vous demandera de réécrire un extrait de texte ; fournissez uniquement le texte de remplacement.",
            "appName": "Vous générez actuellement du texte pour {{appName}}.",
            "userPreferences": "Respectez ces préférences utilisateur quant à la manière dont ils souhaitent que le texte soit généré : {{userPreferences}}.",
            "userPrompt": "Réécrire {{userRequestText}} : {{clipboardText}}"
        },
        "translatePrompt": {
            "systemPrompt": "Vous êtes un assistant de traduction précieux et vous générerez du texte pour l'utilisateur dans l'application qu'il utilise. Ne fournissez aucun détail, explication ou élément superflu à votre texte généré ou traduit ; contentez-vous de ce qui est demandé. N'utilisez pas de Markdown sauf demande expresse. Si l'on vous demande de traduire ou de générer du code, ne fournissez pas d'explications sur le code généré ni de symboles Markdown autour du code. Fournissez simplement le contenu traduit demandé par l'utilisateur, sans rien d'autre. N'utilisez pas de graduations Markdown ni de langue. Contentez-vous du code ; c'est extrêmement important. L'utilisateur vous demandera de traduire un extrait de texte, fournissez uniquement la traduction.",
            "appName": "Vous traduisez actuellement du texte pour {{appName}}.",
            "userPreferences": "Respectez ces préférences utilisateur quant à la manière dont ils souhaitent que le texte soit généré : {{userPreferences}}.",
            "userPrompt": "Traduisez ceci en {{language}} : {{userRequestText}}",
            "genericUserPrompt": "Traduire : {{userRequestText}}"
        },
        "disabled": {
            "title": "Les tâches intelligentes sont désactivées",
            "description": "Il semble que vous ayez désactivé les tâches intelligentes. Effectuez une mise à jour pour déverrouiller la génération de texte, la réécriture et bien plus encore dans vos paramètres."
        }
    },
    "profile": {
        "title": "Contrôles de l'application",
        "titlePlural": "Contrôles de l'application",
        "titlePreview": "Aperçu des commandes",
        "previous": "Contrôles de l'application précédente",
        "manage": "Gérer les contrôles des applications",
        "view": "Contrôles d'affichage",
        "edit": "Modifier les contrôles de l'application",
        "add": "Ajouter des contrôles d'application",
        "create": "Créer des contrôles d'application",
        "warn": "La caméra ou le microphone doivent être démarrés pour utiliser les commandes de votre application.",
        "descriptionShort": "Découvrez les différentes manières dont Cephable vous aide à contrôler vos appareils et logiciels.",
        "name": "Nom de l'application",
        "nameQuestion": "Comment souhaitez-vous appeler ces contrôles d’application ?",
        "newName": "Nouveaux contrôles d'application",
        "search": "Rechercher les contrôles d'application par nom",
        "searchLong": "Rechercher les contrôles d'application par nom ou description",
        "keyboardAndMouse": "Clavier et souris",
        "genericController": "Manette de jeu",
        "keyboardMouseAndController": "Clavier, souris et contrôleur",
        "permissionError": "Vous n'êtes pas autorisé à utiliser ces contrôles d'application.",
        "set": {
            "title": "Il semble que vous n'ayez pas encore défini de contrôles d'application.",
            "cta": "Définir les contrôles de l'application",
            "empty": {
                "auto": "Passez à une autre application pour voir les commandes",
                "select": "Sélectionnez un contrôle pour commencer",
                "none": "Aucun contrôle d'application trouvé"
            },
            "description": "Les contrôles d'application permettent à Cephable de savoir ce qu'il doit écouter et quelles actions il doit entreprendre. Vous pouvez changer de contrôle d'application à tout moment depuis la page d'accueil ou dans vos paramètres de connexion."
        },
        "summary": {
            "title": "Résumé des contrôles de l'application",
            "descriptionLong": "Voici les détails de ces commandes d'application. Vous pouvez rechercher des commandes, des actions et plus encore pour découvrir leurs possibilités.",
            "description": "Obtenez un résumé de ces contrôles d'application, y compris les contrôles existants, les personnalisations, les détails et plus encore.",
            "view": "Afficher le résumé des contrôles de l'application",
            "filter": "Filtrer par type d'entrée",
            "placeholder": "Rechercher les noms de contrôle..."
        },
        "copy": {
            "title": "Copier les contrôles de l'application",
            "duplicate": "Contrôles d'application en double",
            "question": "Créer une copie ?",
            "description": "Vous souhaitez créer une copie de ces contrôles d'application ? Une nouvelle fenêtre s'ouvrira avec ces contrôles copiés, mais ils ne seront ajoutés à votre compte qu'après leur enregistrement.",
            "confirm": "Oui, créer une copie",
            "profileSuffix": "{{name}} (copie)"
        },
        "new": {
            "title": "Créer de nouveaux contrôles d'application",
            "description": "Créez des commandes personnalisées à partir de zéro ou laissez l'IA de pointe générer des commandes personnalisées, vous permettant de naviguer sans effort dans les applications et les logiciels à l'aide de votre voix, de votre tête et de vos gestes du visage.",
            "note": "Recommandé pour les utilisateurs avancés.",
            "scratch": "Créer à partir de zéro"
        },
        "advancedOptions": "Options de contrôle avancées",
        "delete": {
            "title": "Supprimer les contrôles de l'application",
            "titleLong": "Supprimez ces contrôles d'application",
            "description": "Vous pouvez supprimer ces contrôles d'application en cliquant sur « Supprimer les contrôles d'application ».",
            "confirm": "Êtes-vous sûr de vouloir supprimer ces contrôles d'application ?",
            "confirmLong": "Une fois ces contrôles supprimés, vous ne pourrez plus y revenir. Êtes-vous sûr de vouloir supprimer ces contrôles ?",
            "confirmButton": "Oui, supprimez ces contrôles d'application"
        },
        "current": "Contrôles actuels",
        "loading": "Chargement des commandes...",
        "null": "Vous n'avez pas encore de contrôles d'application. Cliquez ci-dessous pour en créer un.",
        "nullButton": "Créez vos premiers contrôles d'application",
        "preview": "Aperçu",
        "features": "Caractéristiques",
        "byline_public": "Par : l'équipe Cephable",
        "byline_shared": "Partagé par : Communauté Cephable",
        "share": {
            "title": "Partager les contrôles de l'application",
            "previewTitle": "Aperçu des contrôles d'applications partagées",
            "description": "Partagez ces contrôles d’application avec d’autres afin qu’ils puissent en obtenir une copie et les personnaliser à partir de là !",
            "descriptionLong": "Partagez ces commandes d'application avec d'autres personnes pour qu'elles puissent en obtenir une copie et les personnaliser ! Choisissez le mode de partage souhaité, puis créez un lien à envoyer.",
            "add": "Créer un lien de partage",
            "confirm": "Partager cette URL",
            "link": "Partager le lien",
            "copy": "Copier le lien",
            "copied": "Copié!",
            "usage": "Montant d'utilisation",
            "created": "Créé {{value}}",
            "expiration": {
                "title": "Expiration",
                "once": "Autoriser une seule utilisation",
                "unlimited": "Autoriser une utilisation illimitée",
                "no": "Aucune expiration",
                "date": "Date d'expiration",
                "dateDescription": "Expire à une date précise"
            },
            "manage": "Gérer les liens de partage précédents",
            "empty": "Aucun partage n'a été créé pour ces contrôles d'application."
        },
        "swap": {
            "title": "Contrôles d'échange",
            "titleLong": "Échangez les commandes de votre application",
            "descriptionShort": "Utilisez différents contrôles d’application pour correspondre au programme ou au logiciel que vous utilisez.",
            "description": "Vous pouvez basculer entre différents contrôles d'application pour correspondre au programme ou au logiciel que vous utilisez."
        },
        "autoProfileSwitching": {
            "title": "Commutation de commande automatique",
            "alerts": {
                "disabled": "La commutation de contrôle automatique est désactivée.",
                "temporarilyDisabled": "La commutation de contrôle automatique est temporairement désactivée.",
                "enabled": "La commutation de contrôle automatique est activée.",
                "error": "Erreur lors de l'enregistrement des préférences de commutation de contrôle automatique"
            },
            "associatedPrograms": {
                "add": "Ajouter un nouveau programme associé",
                "description": {
                    "personal": "Choisissez les logiciels ou programmes que vous souhaitez connecter à ces commandes. Ce système prend en charge la commutation automatique des commandes : Cephable adapte automatiquement les commandes de ces applications au programme que vous utilisez.",
                    "short": "Choisissez le logiciel ou les programmes que vous souhaitez connecter à ces commandes."
                },
                "edit": "Modifier les programmes associés",
                "noOptionsText": "Commencez à taper pour trouver les programmes associés",
                "profileLabel": "Contrôles de l'application :",
                "remove": "Supprimer le programme associé",
                "title": "Programmes associés",
                "when": "Cephable basculera automatiquement les contrôles de mon application sur {{profileName}} lorsque j'utilise...",
                "emptySearch": "Aucun programme n'est associé à ces contrôles.",
                "error": "Erreur lors de l'enregistrement des programmes associés. Veuillez réessayer ultérieurement.",
                "emptyError": "Programme associé vide détecté, veuillez le supprimer avant de continuer."
            },
            "commandOverlay": {
                "command": "Contrôles de commutation d'application : {{value}}"
            },
            "description": "Le changement automatique de contrôle permet à Cephable de s'adapter parfaitement à votre flux de travail. Lorsqu'il est activé, Cephable ajuste les contrôles de votre application en fonction du programme ou du logiciel utilisé. S'il est désactivé, vous pouvez changer manuellement de contrôle d'application à l'aide du bouton « Changer de contrôle » ou des commandes globales."
        },
        "error": {
            "noMatch": "Aucun contrôle d'application ne correspond à votre recherche.",
            "load": "Erreur lors du chargement des contrôles de l'application.",
            "add": "Erreur lors de l'ajout des contrôles d'application.",
            "delete": "Erreur lors de la suppression des contrôles de l'application.",
            "audioEventsWithEmptyCommands": "Il manque des contrôles dans votre réponse. Vérifiez-les pour vous assurer de les remplir complètement.",
            "conflicts": "Erreur lors de l'enregistrement des contrôles de l'application en raison de conflits.",
            "save": "Erreur lors de l'enregistrement des commandes de l'application. Veuillez réessayer.",
            "device": "Contrôle d'application non valide pour cette connexion. Veuillez en essayer un autre."
        },
        "conflictIndicators": {
            "errorTitle": "Erreur lors de l'enregistrement des contrôles de l'application en raison de conflits",
            "warningTitle": "Contrôles d'application enregistrés avec des avertissements",
            "subtitle": "Les contrôles d'application que vous avez créés ont certaines configurations qui peuvent entrer en conflit.",
            "profileNameErrors": "Conflit de nom des contrôles d'application",
            "emptyControlsMapped": "Noms d'entrée vides",
            "emptyControlsMappedDescription": "Veuillez ajouter une commande vocale, une expression faciale, une inclinaison de la tête ou une autre commande à votre entrée.",
            "emptyKeybindingControlsMapped": "Noms d'entrée vides pour les raccourcis clavier",
            "emptyKeybindingControlsMappedDescription": "Veuillez ajouter une commande vocale, une expression faciale, une inclinaison de la tête ou une autre commande à votre entrée pour les raccourcis clavier.",
            "duplicateNameTitle": "Nom des contrôles d'application en double",
            "duplicateNameDescription": "Vous disposez déjà d'une application portant le même nom. Veuillez la modifier avant de continuer.",
            "emptyNameTitle": "Nom des contrôles d'application vides",
            "emptyNameDescription": "Les commandes de l'application doivent avoir un nom, par exemple Jeu 1, Spotify, Word, etc.",
            "macrosReleaseKeysMissingTitle": "Sorties avec des clés non libérées",
            "macrosReleaseKeysMissingDescription": "Veuillez ajouter une clé de déverrouillage ou arrêter toutes les étapes pour éviter que les clés ne se bloquent.",
            "duplicateInputCommandMacroTitle": "Entrées de commande identiques",
            "duplicateCommandsDescription": "Veuillez supprimer ou modifier les commandes d'entrée en double.",
            "duplicateInputCommandBindingsTitle": "Entrées de contrôle identiques pour les raccourcis clavier",
            "conflictIndicatorDisplayString": "{{container}} : {{commandOrKeyName}} avec {{commandOrEventType}}",
            "duplicateMacroNames": "Noms de contrôle en double",
            "duplicateMacroNamesDescription": "Veuillez supprimer ou modifier l’un de vos noms de contrôle identiques.",
            "warningIgnore": "Ignorer",
            "warningDoNotShowAgain": "Ne plus afficher les avertissements",
            "macrosVoiceCommandConflictWithDictationTitle": "Contrôlez les commandes vocales de la même manière que les mots clés de la dictée",
            "keybindingsVoiceCommandConflictWithDictationTitle": "Les raccourcis clavier des commandes vocales sont identiques à ceux des mots clés de la dictée",
            "macrosVoiceCommandConflictWithDictationDescription": "Vos entrées vocales déclencheront la dictée et les commandes vocales.",
            "keybindingsVoiceCommandConflictWithDictationDescription": "Vos entrées vocales déclencheront la dictée et les pressions sur les touches.",
            "macrosVoiceCommandConflictWithGenerationTitle": "Contrôler les commandes vocales de la même manière que les mots clés de génération",
            "keybindingsVoiceCommandConflictWithGenerationTitle": "Les commandes vocales des raccourcis clavier sont identiques aux mots clés de génération",
            "macrosVoiceCommandConflictWithGenerationDescription": "Vos entrées vocales déclencheront la génération et les commandes vocales.",
            "keybindingsVoiceCommandConflictWithGenerationDescription": "Vos entrées vocales déclencheront la génération et les pressions sur les touches.",
            "duplicateAssociatedProgramNames": "Noms de programmes associés en double",
            "duplicateAssociatedProgramNamesDescription": "Veuillez supprimer ou modifier l'un de vos programmes associés identiques.",
            "emptyEvent": {
                "title": "Étapes manquantes",
                "description": "Il manque des étapes dans vos contrôles. Cela pourrait empêcher Cephable d'exécuter une action lorsque vous donnez une commande."
            }
        },
        "success": {
            "save": "Contrôles de l'application enregistrés.",
            "add": "Contrôles d'application ajoutés.",
            "delete": "Contrôles de l'application supprimés.",
            "share": "Lien de partage créé et copié dans le presse-papiers",
            "shareDelete": "Lien de partage supprimé.",
            "generate": "Contrôles d'application générés."
        },
        "warning": "Contrôles d'application enregistrés avec des avertissements",
        "customize": "Personnaliser les contrôles de l'application",
        "custom": "{{name}} (Personnalisé)",
        "description": "Les contrôles d'application sont un ensemble de commandes permettant de contrôler votre appareil ou votre connexion. Vous pouvez créer plusieurs contrôles d'application et passer de l'un à l'autre à tout moment."
    },
    "publicProfiles": {
        "toolbar": "Explorer les commandes de l'application",
        "title": "Explorer les commandes de l'application",
        "offline": {
            "title": "Impossible de charger les contrôles d'application publics",
            "description": "Il semble que vous soyez hors ligne. Vous pouvez toujours utiliser les commandes de votre application, mais vous ne pourrez pas charger de nouvelles commandes publiques.",
            "confirm": "D'accord"
        },
        "announcement": "{{count}} De nouveaux contrôles d'application ont été chargés",
        "description": {
            "personal": "Des contrôles d'application publics sont disponibles pour vous aider à démarrer rapidement avec Cephable sur vos applications préférées. Vous pouvez utiliser les contrôles par défaut, les personnaliser selon vos besoins ou créer de toutes nouvelles commandes personnalisées.",
            "pro": "Des contrôles d'application publics sont disponibles pour vous aider à démarrer rapidement avec Cephable sur vos applications préférées. Vous pouvez utiliser les contrôles par défaut, les personnaliser selon vos besoins ou créer de nouveaux contrôles d'application personnalisés grâce au générateur de contrôles."
        },
        "team": "Équipe Cephable"
    },
    "publicTag": "Publique",
    "tray": {
        "panel": "Basculer le panneau",
        "dashboard": "Afficher le tableau de bord",
        "quit": "Quitter Cephable"
    },
    "generate": "Générer",
    "stop": "Arrêt",
    "clear": "Clair",
    "rewrite": "Récrire",
    "translate": "Traduire",
    "smartTasks": {
        "title": "Tâches intelligentes",
        "show": "Afficher les tâches intelligentes",
        "description": "Les tâches intelligentes sont les différentes tâches que l'IA de Cephable peut effectuer pour vous. Ces tâches, alimentées par l'IA intégrée à l'appareil, peuvent être utilisées pour créer du texte, résumer, réécrire, traduire, prendre des notes et discuter avec des documents.",
        "generateText": {
            "title": "Générer du texte",
            "description": "Créez du contenu textuel en fonction de vos entrées ou de vos invites.",
            "label": "Décrivez ce que vous souhaitez générer"
        },
        "summarizeText": {
            "title": "Résumer le texte",
            "description": "Condensez un texte long en un résumé concis.",
            "directions": "Saisissez le texte à résumer, ou Cephable utilisera automatiquement le texte que vous avez mis en évidence."
        },
        "rewriteText": {
            "title": "Réécrire le texte",
            "description": "Surlignez le texte dans une autre application dans laquelle vous écrivez, puis revenez ici et décrivez comment vous souhaitez qu'il soit réécrit.",
            "label": "Décrivez comment vous souhaitez réécrire le texte",
            "inputLabel": "Saisissez le texte à réécrire"
        },
        "translateText": {
            "title": "Traduire le texte",
            "description": "Saisissez le texte à traduire, ou Cephable utilisera automatiquement le texte que vous avez mis en surbrillance.",
            "label": "Entrez le texte à traduire",
            "languageLabel": "Langue à traduire"
        },
        "noteTaker": {
            "title": "Preneur de notes",
            "description": "Laissez Cephable enregistrer et transcrire localement vos réunions ou conversations"
        },
        "documentChat": {
            "title": "Discussion sur les documents",
            "description": "Interagissez avec des documents et interrogez-les pour obtenir des informations rapides."
        },
        "highlightText": {
            "title": "Utiliser le texte en surbrillance",
            "description": "Cephable peut utiliser automatiquement le texte surligné dans n'importe quelle application pour effectuer des tâches telles que la synthèse, la réécriture ou la traduction. Vous pouvez également saisir du texte manuellement si vous le souhaitez.",
            "label": "Entrez le texte à utiliser",
            "placeholder": "Vous pouvez également surligner du texte dans une autre application et revenir ici pour l'utiliser."
        },
        "pasteText": {
            "title": "Coller du texte",
            "description": "Cephable peut utiliser automatiquement le texte copié dans votre presse-papiers pour effectuer des tâches telles que la synthèse, la réécriture ou la traduction. Vous pouvez également saisir du texte manuellement si vous le souhaitez.",
            "label": "Entrez le texte à utiliser",
            "placeholder": "Vous pouvez également surligner du texte dans une autre application et revenir ici pour l'utiliser."
        },
        "clearCache": "Si vous rencontrez des problèmes lors de la génération, veuillez vider votre cache et vos ressources dans les paramètres de génération de texte et réessayer.",
        "transcribeAudio": {
            "title": "Transcrire l'audio",
            "description": "Convertissez des fichiers audio ou vidéo en texte à l'aide de la transcription IA.",
            "inputMethod": "Choisissez la méthode de saisie",
            "localFile": "Fichier local",
            "url": "URL",
            "selectFile": "Sélectionner un fichier audio/vidéo",
            "urlLabel": "URL audio/vidéo",
            "transcribe": "Transcrire",
            "result": "Résultat de la transcription",
            "invalidFileType": "Veuillez sélectionner un fichier audio ou vidéo valide (mp3, wav, ogg, mp4, webm, mov, avi)",
            "error": "Erreur de transcription",
            "history": {
                "title": "Historique de la transcription",
                "description": "Affichez et gérez vos transcriptions enregistrées.",
                "viewHistory": "Afficher l'historique",
                "empty": "Aucune transcription pour le moment. Commencez à transcrire pour enrichir votre histoire !",
                "titleLabel": "Titre (facultatif)",
                "titlePlaceholder": "Entrez un titre pour cette transcription",
                "textLabel": "Texte de transcription",
                "confirmDelete": "Êtes-vous sûr de vouloir supprimer cette transcription ?"
            }
        }
    },
    "inputMethod": "Méthode de saisie :",
    "hotkey": {
        "title": "Bouton d'action rapide",
        "titlePlural": "Boutons d'action rapide",
        "titlePanel": "Actions rapides",
        "label": "Nom d'affichage du bouton d'action rapide",
        "placeholder": "Nom à afficher",
        "question": "Comment souhaitez-vous nommer ce bouton ?",
        "when": "Quand je tape...",
        "description": "Les boutons d'action rapide vous permettent de créer des boutons à appuyer depuis l'application Companion. Vous pouvez créer autant de boutons que vous le souhaitez, et ils rempliront l'écran de votre téléphone ou de votre tablette.",
        "usagePrompt": "Les boutons d'action rapide sont accessibles depuis l'application compagnon sur smartphone ou tablette. Téléchargez notre application mobile sur Google Play et l'App Store d'iOS.",
        "reorder": "Vous pouvez réorganiser l'ordre en utilisant les boutons de déplacement vers le haut et vers le bas.",
        "emptyTitle": "Pas de boutons d'action rapide",
        "edit": "Modifier les boutons d'action rapide",
        "tap": "Appuyez sur {{value}}",
        "copySuffix": "{{name}}_copie",
        "hotkeysOnly": "Boutons personnalisés",
        "allControls": "Toutes les commandes de l'application",
        "show": "Afficher les boutons d'action rapide",
        "deprecatedDialog": {
            "title": "Les contrôles de votre application nécessitent une mise à jour.",
            "description2": "Une simple mise à jour suffit – une seconde à peine – et vous profiterez d'une personnalisation fluide des boutons. Dites adieu aux étapes supplémentaires et bonjour à une interface plus conviviale. Prêt à passer à l'action ?",
            "confirm": "Faisons-le!",
            "description1": "Il semble que vous utilisiez d'anciennes commandes d'application avec des boutons d'action rapide. Nous vous réservons des mises à jour intéressantes ! Nous avons repensé le système pour simplifier la création et la modification des boutons d'action rapide, sans avoir à explorer les paramètres avancés."
        },
        "demo": {
            "title": "Boutons d'action rapide de démonstration",
            "step1": "Activer les boutons d'action rapide",
            "step2": "Utilisez les exemples d’invite ci-dessous pour contrôler le bloc de texte.",
            "command1": "Appuyez sur le bouton 1 pour « Agrandir le texte »",
            "command2": "Appuyez sur le bouton 2 pour « mettre le texte en gras »",
            "command3": "",
            "continue": "Continuer avec les boutons d'action rapide",
            "description": "La zone de démonstration ci-dessous vous permettra d'essayer les boutons d'action rapide. Elle se limite au contrôle spécifique de la zone de texte ci-dessous."
        },
        "example": {
            "title": "Exemples de boutons d'action rapide",
            "command1": "Appuyez sur Pause",
            "example1": "Exemple « mettre la vidéo en pause »",
            "command2": "Appuyez sur Suivant",
            "example2": "Exemple « zoom arrière »",
            "command3": "Appuyez sur Arrêter",
            "example3": "Exemple « fermer la fenêtre »",
            "description": "Ces exemples illustrent la polyvalence des boutons d'action rapide pour contrôler votre appareil ou votre connexion. Ils permettent d'exécuter des commandes, de naviguer dans les interfaces ou d'effectuer des actions d'un simple toucher."
        },
        "emptySearch": "Aucune action rapide ne correspond à ce critère.",
        "empty": "Il semble que vous n'ayez actuellement aucune action rapide.",
        "emptyLong": "Aucun bouton d'action rapide n'est configuré dans ces commandes d'application. Une fois que vous aurez ajouté des boutons d'action rapide ou choisi des commandes d'application avec un bouton d'action rapide, ils apparaîtront ici."
    },
    "reset": "Réinitialiser",
    "info": "Plus d'informations",
    "device": {
        "title": "Connexion",
        "titlePlural": "Relations",
        "status": {
            "title": "État de la connexion :",
            "connected": {
                "application": "Application connectée",
                "connection": "Connecté",
                "device": "Appareil connecté",
                "game": "Jeu connecté"
            },
            "disconnected": {
                "application": "Application déconnectée",
                "connection": "Déconnecté",
                "device": "Appareil déconnecté",
                "game": "Jeu déconnecté"
            }
        },
        "running": "En cours d'exécution",
        "offline": "Hors ligne",
        "otherDevices": "Autres connexions de sortie",
        "currentStatus": "Statut actuel :",
        "connectionStatus": "État de la connexion :",
        "profileStatus": "Contrôles actuels de l'application :",
        "name": {
            "title": "Nom de la connexion",
            "question": "Comment voulez-vous appeler cette connexion ?",
            "description": "Donnez un nom à votre connexion afin de pouvoir la retrouver facilement plus tard.",
            "placeholder": "nom de la connexion",
            "edit": "Modifier le nom de la connexion"
        },
        "updates": {
            "title": "Mises à jour de connexion",
            "settings": "Paramètres de mise à jour de la connexion",
            "description": "Vérifiez les mises à jour du micrologiciel de connexion et modifiez les paramètres de mise à jour automatique",
            "edit": "Modifier les paramètres de mise à jour",
            "check": {
                "title": "Vérifier les mises à jour",
                "processing": "Vérification des mises à jour ! Cela peut prendre quelques minutes et votre connexion peut redémarrer pendant les mises à jour.",
                "description": "Appuyez pour vérifier les mises à jour de votre connexion. Si une mise à jour est disponible et que votre connexion est active, la mise à jour commencera. Les mises à jour peuvent prendre quelques minutes."
            },
            "auto": {
                "title": "Mise à jour automatique",
                "description": "Lorsque ce paramètre est activé, votre connexion se met automatiquement à jour dès qu'une mise à jour est disponible. Si ce paramètre est désactivé, appuyez sur le bouton de mise à jour pour obtenir la dernière version.",
                "option": "Utiliser la mise à jour automatique ?"
            }
        },
        "delete": {
            "title": "Supprimer la connexion",
            "titleLong": "Supprimer la connexion du compte",
            "description": "Vous pouvez supprimer cette connexion de votre compte en cliquant ci-dessous. Cette opération est irréversible.",
            "confirm": "Êtes-vous sûr de vouloir supprimer cette connexion ?",
            "confirmLong": "Voulez-vous vraiment annuler l'enregistrement et réinitialiser cette connexion ? Vous ne pourrez plus vous y connecter, envoyer des commandes ni la mettre à jour. Après cette annulation et cette réinitialisation, n'importe qui d'autre pourra configurer cette connexion de zéro.",
            "confirmButton": "Oui, supprimez cette connexion."
        },
        "manage": {
            "title": "Cliquez pour afficher et gérer les détails de vos connexions.",
            "description": "",
            "name": "Personnalisez le nom de votre connexion pour une gestion plus facile."
        },
        "error": {
            "save": "Erreur lors de l'enregistrement de la connexion.",
            "load": "Erreur lors du chargement de la connexion.",
            "add": "Erreur lors de l'ajout de la connexion.",
            "delete": "Erreur lors de la suppression de la connexion.",
            "updates": "Erreur lors de la vérification des mises à jour.",
            "connection": "La connexion n'est pas établie. Vérifiez qu'elle est bien établie avant de réessayer.",
            "deleteLong": "Nous n'avons pas pu supprimer cette connexion de votre compte. Si vous vous reconnectez à ce compte, vous devrez peut-être la supprimer manuellement dans les paramètres de connexion."
        },
        "success": {
            "save": "Connexion enregistrée.",
            "add": "Connexion ajoutée.",
            "delete": "Connexion supprimée."
        },
        "description": "Cephable prend en charge plusieurs appareils et connexions. Vous pouvez gérer les paramètres ou sélectionner l'un d'entre eux. Cet ordinateur sera toujours votre connexion principale. Vous pourrez ajouter d'autres connexions ultérieurement.",
        "swap": {
            "titlePlural": "Connexions d'échange"
        },
        "control": {
            "button": "Contrôle {{name}}",
            "description": {
                "application": "Contrôlez cette application connectée avec votre voix, des actions rapides, des mouvements de tête, etc. Par exemple, si vous dites « Enregistrer », cela enregistrera l'application en cours d'exécution.",
                "connection": "Contrôlez cette connexion avec votre voix, des actions rapides, des mouvements de tête, etc. Par exemple, si vous dites « Enregistrer », votre connexion en cours sera sauvegardée.",
                "device": "Contrôlez cet appareil connecté avec votre voix, des actions rapides, des mouvements de tête, etc. Par exemple, si vous dites « Ouvrir Spotify », Spotify s'ouvrira sur l'appareil en cours d'exécution.",
                "game": "Contrôlez ce jeu connecté avec votre voix, des actions rapides, des mouvements de tête et bien plus encore. Par exemple, si vous dites « Go », le joueur se déplacera en course."
            },
            "generic": "Connexion de contrôle"
        }
    },
    "explore": "Explorer",
    "shortcuts": {
        "title": "Raccourcis mondiaux",
        "description": "Personnalisez les raccourcis clavier pour un accès rapide aux commandes Cephable depuis n'importe où sur votre système.",
        "info": "Ces raccourcis fonctionnent globalement et peuvent être utilisés même lorsque Cephable n'est pas la fenêtre active.",
        "shortcut": "Raccourci",
        "toggleMicrophone": "Basculer le microphone",
        "toggleDictation": "Basculer le mode dictée",
        "toggleVoiceControl": "Basculer le mode de commande vocale",
        "togglePanel": "Basculer le panneau",
        "registrationFailed": "Certains raccourcis globaux n'ont pas pu être enregistrés. Ils sont peut-être utilisés par une autre application :",
        "record": {
            "title": "Raccourci d'enregistrement",
            "start": "Cliquez pour enregistrer",
            "listening": "Appuyez sur la combinaison de touches souhaitée...",
            "pressKeys": "Appuyez sur les touches maintenant"
        },
        "formatHint": "Sélectionnez au moins une touche de modification ({{modifierKey}}, {{modifierKey2}}, Shift) et une autre touche."
    },
    "gamepad": {
        "title": "Prise en charge de la manette de jeu",
        "description": "Configurer la sortie du gamepad et du joystick pour les jeux sur PC",
        "driver": {
            "description": "Pour prendre en charge les sorties de la manette de jeu, Cephable doit télécharger et installer un pilote externe appelé ViGEm. Ce pilote active la fonctionnalité de manette virtuelle Xbox 360, reconnue nativement par les jeux.",
            "installed": "Pilote de manette de jeu installé : vous pouvez utiliser les sorties de la manette ! Si vous rencontrez toujours des problèmes, vous pouvez essayer de réinstaller le pilote.",
            "notInstalled": "Pilote du contrôleur de jeu non installé",
            "install": "Installer le pilote du contrôleur de jeu",
            "reinstall": "Réinstaller le pilote du contrôleur de jeu",
            "installing": "Installation du pilote du contrôleur de jeu ViGEm...",
            "installSuccess": "Le pilote de la manette de jeu ViGEm a été installé avec succès ! Vous pouvez désormais utiliser les sorties de la manette dans vos commandes.",
            "installFailed": "Échec de l'installation du pilote ViGEm. Veuillez réessayer ou procéder à l'installation manuelle depuis le site web de ViGEm."
        },
        "platform": {
            "unsupported": "Plateforme non prise en charge pour les fonctionnalités de la manette",
            "unsupportedDescription": "La fonctionnalité de sortie du contrôleur de jeu n'est actuellement prise en charge que sur les systèmes Windows x64. La prise en charge de Windows ARM64 n'est pas encore disponible en raison des limitations du SDK."
        },
        "usage": "Une fois le pilote du contrôleur de jeu installé, vous pouvez utiliser les mouvements du joystick et les pressions sur les boutons de la manette dans vos macros et commandes vocales pour contrôler les jeux."
    },
    "youtube": {
        "unavailable": {
            "title": "Vidéo indisponible",
            "description": "Cette vidéo est actuellement indisponible. Veuillez la réessayer ultérieurement.",
            "retry": "Réessayer"
        },
        "watch": {
            "title": "Oups.",
            "description": "Il semble qu'un problème soit survenu lors du chargement de la vidéo. Vous pouvez la regarder directement sur YouTube.",
            "button": "Regarder sur YouTube"
        },
        "offline": {
            "title": "Vidéo indisponible",
            "description": "Cette vidéo YouTube nécessite une connexion internet pour se charger. Veuillez vérifier votre connexion et réessayer."
        }
    },
    "metrics": {
        "download": {
            "success": "Accès réussi au fichier de métriques.",
            "manualPath": "Fichier de métriques disponible à : {{path}}",
            "error": "Erreur lors du téléchargement du fichier de métriques.",
            "noFile": "Aucun fichier de métriques trouvé."
        },
        "clear": {
            "success": "Le fichier de métriques a été effacé avec succès.",
            "error": "Erreur lors de l'effacement du fichier de métriques.",
            "noFile": "Aucun fichier de métriques n'a été trouvé pour être effacé.",
            "confirm": "Voulez-vous vraiment effacer toutes les données ? Cette action est irréversible."
        }
    },
    "suggestedPrompts": {
        "title": "Suggestions d'invites",
        "description": "Personnalisez les invites suggérées qui s'affichent dans les tâches d'IA pour vous aider à démarrer rapidement.",
        "edit": "Modifier les invites suggérées",
        "generate": "Générer du texte",
        "rewrite": "Réécrire le texte",
        "addGenerate": "Ajouter une invite de génération",
        "addRewrite": "Ajouter une invite de réécriture",
        "remove": "Supprimer l'invite",
        "generatePlaceholder": "Entrez une invite pour la génération de texte...",
        "rewritePlaceholder": "Entrez une invite pour la réécriture du texte...",
        "suggested": "Suggestions d'invites",
        "suggestedFor": "Suggéré pour {{profileName}}",
        "seeAll": "Voir toutes les invites",
        "showLess": "Afficher moins",
        "allPrompts": "Toutes les invites",
        "customFor": "Invites personnalisées pour {{profileName}}",
        "defaultPrompts": "Invites par défaut",
        "defaultGenerate": [
            "Un e-mail professionnel présentant notre nouveau produit",
            "Un ordre du jour pour la discussion d'équipe de la semaine prochaine",
            "Un aperçu de la proposition de projet pour une nouvelle initiative",
            "Un modèle de lettre commerciale formelle",
            "Une section de documentation technique",
            "Introduction au manuel d'utilisation",
            "Un aperçu du document de formation",
            "Un projet de document de politique",
            "Un e-mail de suivi après une réunion",
            "Un message de remerciement à un client",
            "Un e-mail de mise à jour de l'état du projet",
            "Une invitation à un événement d'entreprise",
            "Un e-mail de rappel pour les échéances à venir",
            "Un e-mail de bienvenue pour les nouveaux membres de l'équipe",
            "Un e-mail d'excuses pour l'interruption de service",
            "Une introduction à la newsletter",
            "Une liste de brainstorming pour les campagnes marketing",
            "Solutions créatives pour améliorer la productivité des équipes",
            "Idées d'activités pour une retraite d'entreprise",
            "Concepts pour une nouvelle fonctionnalité d'application mobile",
            "Suggestions pour améliorer l'expérience client",
            "Idées d'innovation pour le développement de nos produits",
            "Idées de contenu pour les publications sur les réseaux sociaux",
            "Thèmes d'atelier pour le développement professionnel",
            "Une fonction qui valide la saisie de l'utilisateur",
            "Une requête de base de données pour la gestion des utilisateurs",
            "Code de gestion des erreurs pour les requêtes API",
            "Un modèle de fichier de configuration",
            "Commentaires expliquant un algorithme complexe",
            "Cas de tests unitaires pour une nouvelle fonctionnalité",
            "Documentation pour les points de terminaison de l'API",
            "Un script pour un déploiement automatisé"
        ],
        "defaultRewrite": [
            "Rendre ce texte plus concis et précis",
            "Développez ce résumé avec plus de détails",
            "Reformater ceci comme une liste numérotée",
            "Convertissez ceci en puces",
            "Restructurez ceci en paragraphes clairs",
            "Rendre ce texte plus facile à parcourir rapidement",
            "Organiser ces informations de manière hiérarchique",
            "Formatez ceci comme un guide étape par étape",
            "Rendez ce message plus professionnel et formel",
            "Réécrivez ceci pour qu'il paraisse plus décontracté et amical",
            "Ajustez le ton pour être plus encourageant",
            "Rendez ce son plus confiant et affirmé",
            "Adoucir le ton pour être plus diplomate",
            "Ajoutez de l'enthousiasme et de l'énergie à ce texte",
            "Rendez cela plus empathique et compréhensif",
            "Réécrire avec un ton plus collaboratif",
            "Simplifiez ceci pour un public général",
            "Rendre cette explication plus technique et détaillée",
            "Décomposez ce concept complexe en termes plus simples",
            "Ajoutez plus de contexte et d'informations générales",
            "Résumez ceci en points clés à retenir",
            "Développez les points principaux avec des exemples",
            "Rendre cela plus accessible aux débutants",
            "Condensez ceci tout en gardant les informations essentielles",
            "Améliorer la clarté et la lisibilité",
            "Rendez cela plus engageant et intéressant",
            "Ajuster pour une meilleure grammaire et un meilleur flux",
            "Réécrire pour mettre l'accent sur les avantages"
        ]
    },
    "accessibilityService": {
        "error": {
            "generic": "Erreur interne. Veuillez réessayer plus tard.",
            "elementNotFound": "Aucun résultat trouvé pour '{{name}}'. Veuillez vérifier que la recherche existe et réessayer.",
            "highlightOnConflict": "Plusieurs éléments ont été trouvés sous le nom « {{name}} ». Veuillez préciser votre commande afin d'indiquer celui que vous souhaitez sélectionner.",
            "clickNotInitialized": "La fonction « Appuyer par nom » n'est pas disponible pour le moment. Veuillez contacter l'assistance si le problème persiste."
        },
        "clickWait": "Initialisation en cours. Veuillez patienter un instant et réessayer."
    }
}
